/* ═══════════════════════════════════════════════════════════════════════
   COMPORTEMENT MOBILE — 0 à 767 px
   ═══════════════════════════════════════════════════════════════════════

   Complète conf-mobile.css. La mise en page est faite en CSS ; ce fichier
   n'ajoute que ce que le CSS ne peut pas faire :

     1. Une poignée pour REFERMER la feuille montante.
        En desktop, un panneau reste toujours ouvert (choix assumé, voir
        togglePanel() dans conf-sidebar-modern.js). En mobile la feuille
        couvre le produit : il FAUT pouvoir la fermer.

     2. Un voile qui ferme au tap, et le glissement vers le bas.

     3. Empêcher l'ouverture automatique au chargement : conf-sidebar-modern.js
        appelle openPanel("panel-product") au boot, ce qui masquerait le
        produit dès l'arrivée sur la page.

   PRINCIPE : on ne modifie AUCUNE fonction existante. On observe la classe
   .open et on ajoute nos propres éléments. Le desktop n'est jamais touché
   (toutes les actions sont derrière isMobile()).
   ═══════════════════════════════════════════════════════════════════════ */

(function () {
  "use strict";

  var MQ = "(max-width: 767px)";

  function isMobile() {
    return window.matchMedia(MQ).matches;
  }

  /* ── Ouverture automatique au boot ──────────────────────────────────
     conf-sidebar-modern.js ouvre « Type de produit » au chargement. Sur
     mobile, cela recouvrirait le produit avant même la première action.
     On referme donc la feuille tant que l'utilisateur n'a rien demandé.

     `userOpened` bascule au premier clic sur un bouton du rail : à partir
     de là, les ouvertures sont volontaires et on ne les contrarie plus.  */
  var userOpened = false;

  function closeAllPanels() {
    document.querySelectorAll(".side-panel.open").forEach(function (p) {
      p.classList.remove("open");
    });
    document.querySelectorAll(".icon-nav-item.active").forEach(function (i) {
      i.classList.remove("active");
    });
    /* PASSAGE OBLIGÉ DE TOUTE FERMETURE — le voile, la poignée, une autre
       feuille qui s'ouvre y mènent tous. Le chevron du bouton Taille s'y
       remet donc à l'endroit, quel que soit le chemin emprunté ; le suivre
       depuis chaque appelant en aurait oublié un.

       Garde `typeof` : cette fonction s'exécute avant la déclaration du
       chevron au tout premier rendu. */
    if (typeof majChevronTailleQte === "function") majChevronTailleQte();
    if (typeof majChevronQuantite === "function") majChevronQuantite();
  }

  /* ── Voile ────────────────────────────────────────────────────────── */

  function getScrim() {
    var s = document.getElementById("sheet-scrim");
    if (!s) {
      s = document.createElement("div");
      s.id = "sheet-scrim";
      s.className = "sheet-scrim";
      s.addEventListener("click", closeSheet);
      document.body.appendChild(s);
    }
    return s;
  }

  function showScrim(on) {
    var s = getScrim();
    // Force un reflow pour que la transition d'opacité démarre bien.
    if (on) {
      s.offsetHeight;
      s.classList.add("show");
    } else {
      s.classList.remove("show");
    }
  }

  /* ── Fermeture ────────────────────────────────────────────────────── */

  function closeSheet() {
    if (!isMobile()) return;
    closeAllPanels();
    showScrim(false);
  }

  /* ── Poignée : injectée en haut de chaque panneau ──────────────────
     Placée en premier enfant pour rester au-dessus du contenu qui défile. */

  function addHandle(panel) {
    if (panel.querySelector(".sheet-handle")) return;

    var h = document.createElement("div");
    h.className = "sheet-handle";
    h.setAttribute("role", "button");
    h.setAttribute("aria-label", "Fermer le panneau");
    h.addEventListener("click", closeSheet);

    attachDrag(h, panel);
    panel.insertBefore(h, panel.firstChild);
  }

  /* ── Glissement vers le bas pour fermer ────────────────────────────
     Sous ~90 px on repose le panneau, au-delà on ferme. Le seuil évite
     qu'un simple appui maladroit referme la feuille.                    */

  function attachDrag(handle, panel) {
    var startY = 0;
    var delta = 0;
    var dragging = false;

    handle.addEventListener(
      "touchstart",
      function (e) {
        if (!isMobile()) return;
        dragging = true;
        delta = 0;
        startY = e.touches[0].clientY;
        panel.style.transition = "none";
      },
      { passive: true },
    );

    handle.addEventListener(
      "touchmove",
      function (e) {
        if (!dragging) return;
        delta = e.touches[0].clientY - startY;
        // Vers le haut : rien. La feuille a une hauteur fixe.
        if (delta < 0) delta = 0;
        panel.style.transform = "translateY(" + delta + "px)";
      },
      { passive: true },
    );

    function end() {
      if (!dragging) return;
      dragging = false;
      panel.style.transition = "";
      panel.style.transform = "";
      if (delta > 90) closeSheet();
    }

    handle.addEventListener("touchend", end);
    handle.addEventListener("touchcancel", end);
  }

  /* ── Synchronisation du voile avec l'état des panneaux ─────────────
     openPanel()/closePanel() de conf-sidebar-modern.js posent ou retirent
     .open sans rien nous signaler. Plutôt que de les remplacer (risque de
     casser le desktop), on OBSERVE la classe : le comportement d'origine
     reste seul maître de l'ouverture.                                    */

  function syncScrim() {
    if (!isMobile()) {
      showScrim(false);
      return;
    }
    var open = document.querySelector(".side-panel.open");

    // Ouverture non sollicitée au chargement : on la referme.
    if (open && !userOpened) {
      closeAllPanels();
      showScrim(false);
      return;
    }
    showScrim(!!open);
  }

  function observePanels() {
    var obs = new MutationObserver(syncScrim);
    document.querySelectorAll(".side-panel").forEach(function (p) {
      obs.observe(p, { attributes: true, attributeFilter: ["class"] });
    });
  }

  /* ── Fermeture au clic à l'extérieur ────────────────────────────────
     Le voile suffirait en théorie, mais il ne couvre pas les éléments qui
     lui passent devant (barre d'action, rail, colonne de vues) et dépend de
     l'ordre d'exécution des scripts. On écoute donc le document : tout clic
     hors de la feuille la referme.

     En phase de CAPTURE, sinon un `stopPropagation()` d'un autre handler
     nous priverait de l'événement.

     Exceptions — ne PAS fermer si le clic vise :
       • la feuille elle-même,
       • le rail (c'est lui qui ouvre : fermer ici annulerait l'ouverture au
         même clic),
       • une modale ou un menu ouvert par-dessus (couleur, taille, guide…),
         sinon on refermerait la feuille sous les pieds de l'utilisateur.  */

  function onDocPointerDown(e) {
    if (!isMobile()) return;
    if (!document.querySelector(".side-panel.open")) return;

    var t = e.target;
    if (!t || !t.closest) return;

    if (
      t.closest(".side-panel") ||
      t.closest(".icon-nav") ||
      t.closest(".cv-opt-pop") ||
      t.closest(".cv-opts") ||
      t.closest(".modal-overlay") ||
      t.closest(".sg-modal-overlay") ||
      t.closest(".size-qty-overlay") ||
      t.closest(".simple-grp-overlay") ||
      t.closest(".grp-overlay") ||
      t.closest(".grp-preview-overlay") ||
      t.closest(".qm-overlay") ||
      t.closest(".cart-overlay") ||
      t.closest(".ov-overlay")
    ) {
      return;
    }

    closeSheet();
  }

  /* ── Barre d'action : prix + « Ajouter au panier » ──────────────────
     Le récap est masqué en mobile (voir conf-mobile.css §6) : sans cette
     barre, plus aucun moyen de commander.

     On DÉPLACE les nœuds réels au lieu de les cloner. Un clone aurait exigé
     de dupliquer la mise à jour du prix et le onclick ; en déplaçant, tout
     le code existant (addToCart, refreshPrice…) continue de viser les mêmes
     éléments, par leurs mêmes IDs.

     Les produits coins/drapeaux/patchs réécrivent .recap.innerHTML en
     entier : nos nœuds y sont alors recréés (donc de nouveau à l'intérieur
     du récap masqué). D'où la réinstallation après chaque réécriture, via
     l'observateur ci-dessous.                                            */

  /* Hauteur de la barre d'options (.icon-nav, ancrée en bas). Elle varie :
     libellés sur une ou deux lignes, 3 boutons ou 4 selon la catégorie.
     Le canvas s'en sert pour réserver la place (--nav-h) et la barre elle-
     même est collée au bord bas de l'écran. */
  function measureNav() {
    var nav = document.querySelector(".icon-nav");
    if (!nav) return;
    if (!isMobile()) {
      document.documentElement.style.removeProperty("--nav-h");
      return;
    }
    var h = nav.getBoundingClientRect().height;
    if (h) {
      document.documentElement.style.setProperty(
        "--nav-h",
        Math.round(h) + "px",
      );
    }
  }

  /* Prix et bouton d'ajout reportés dans le HEADER : le bas de l'écran est
     pris par le menu d'options, et le récap est masqué. Sans ce report, il
     n'y aurait plus aucun moyen de commander depuis le mobile.

     On DÉPLACE les nœuds réels — pas de clone : le code existant
     (addToCart, mise à jour du prix) vise les mêmes IDs et continue donc
     d'opérer tel quel. */
  /* ── Garde de réentrance ────────────────────────────────────────────────
     `fillActionBar` ÉCRIT dans `.recap` : elle y rend `#main-add-to-cart` à son
     hôte `.rp-acts` (voir la purge des éléments déjà déplacés, plus bas). Or
     `observeRecap()` observe `.recap` en `childList + subtree`. Sans garde, le
     cycle est : fillActionBar → appendChild dans .recap → mutation → observer →
     fillActionBar → … L'onglet meurt en quelques secondes.

     Mesuré avant correctif : 3004 mutations en 3 s, puis « Target crashed ».
     C'est ce qui produisait l'écran noir et le rechargement sans fin (le
     navigateur relance l'onglet planté).

     Le verrou est posé sur LA FONCTION, pas sur l'observer : quatre endroits
     l'appellent (`observeRecap`, l'observer du canvas, `init`, `onChange`), et
     un garde par appelant serait oublié au prochain ajout.

     Même motif que `syncing` dans conf-coin-toolbar.js:436. */
  var _fabEnCours = false;

  /* Horodatage de la dernière écriture. Le verrou synchrone ci-dessus ne suffit
     pas : les MutationObserver sont notifiés en MICROTÂCHE, donc APRÈS que
     `_fabEnCours` soit repassé à false. Il faut aussi que l'observer sache
     ignorer les mutations que nous venons de provoquer. */
  var _fabDerniereEcriture = 0;

  function fillActionBar() {
    if (_fabEnCours) return;
    _fabEnCours = true;
    try {
      fillActionBarInterne();
    } finally {
      /* `finally` obligatoire : une exception dans le corps ne doit pas laisser
         le verrou fermé — la barre ne se reconstruirait plus jamais. */
      _fabEnCours = false;
      _fabDerniereEcriture = Date.now();
    }
  }

  function fillActionBarInterne() {
    if (!isMobile()) return;

    /* Ancrés dans .canvas (et non dans le header) : le prix se pose en bas
       à gauche de l'aperçu, le bouton d'ajout en pastille flottante en bas
       à droite. Le header ne garde que le panier — lequel a sa propre
       logique et ne s'affiche qu'une fois un article ajouté. */
    var canvas = document.querySelector(".canvas");
    if (!canvas) return;

    /* Prix et bouton du produit COURANT.

       Chaque récap expose des éléments DIFFÉRENTS : les gabarits injectés par
       conf-dynamic-layout.js utilisent `.rp-unit-price-big` et
       `.rp-btn-primary`, là où le textile a `#rp-price-val` et
       `#main-add-to-cart`. `.recap` étant masqué en mobile, ces éléments sont
       DÉPLACÉS ici, dans `.canvas`.

       On les cherche DANS `.recap`, jamais dans `.canvas` ni dans le document
       entier : un élément déjà déplacé n'est plus enfant du récap, donc
       `recap.innerHTML = …` (reconstruction au changement de produit) ne le
       supprime pas. Il survivrait indéfiniment et masquerait celui du produit
       courant — c'est ce qui empêchait la modale de devis des coins de
       s'ouvrir : le tap atteignait le bouton textile resté en place. */
    var recapNow = document.querySelector(".recap");

    /* Purge des éléments déjà déplacés : on les REND à leur hôte d'origine, on
       ne les détruit JAMAIS.

       Le défaut corrigé : cette boucle ne rendait que `#main-add-to-cart`,
       reconnu par son `id`. Tous les autres boutons partaient par la branche
       `else` — donc `canvas.removeChild()`. Mesuré :

         textile   fab=1  « Ajouter au panier »
         coins     fab=0  ← DÉTRUIT « DEMANDER UN DEVIS »
         patches   fab=0  ← DÉTRUIT « AJOUTER AU PANIER »

       Pourquoi la destruction est fatale : `fillActionBar` cherche le bouton
       DANS `.recap`. Le premier appel l'en retire pour le poser dans `.canvas` ;
       l'observer du canvas rappelle la fonction 60 ms plus tard (4 appels par
       bascule, mesuré), la purge le détruit, et la recherche qui suit ne trouve
       plus rien — ni dans `.recap`, ni ailleurs. Aucun bouton.

       Le textile échappait au défaut UNIQUEMENT parce que son bouton a un `id`
       traité en cas particulier.

       Correctif : mémoriser l'hôte au moment du déplacement (`data-fabHome`),
       et le rendre à cet hôte ici. La fonction devient idempotente — la
       rappeler ne détruit plus ce qu'elle a placé. Si le gabarit a changé et
       que l'hôte n'existe plus, on retombe sur la destruction : le nœud
       appartient alors à un produit qui n'est plus affiché. */
    var stale = canvas.querySelectorAll(".mobile-fab");
    for (var s = 0; s < stale.length; s++) {
      var old = stale[s];
      old.classList.remove("mobile-fab", "mobile-fab-solo");

      /* SEUL `#main-add-to-cart` est rendu à son hôte : il est écrit en dur dans
         le template (sections/configurateur.liquid:846) et n'est JAMAIS
         régénéré. Le détruire le ferait disparaître définitivement.

         Les autres boutons viennent de gabarits que le layout dynamique
         RÉÉCRIT à chaque bascule : un exemplaire neuf existe déjà dans `.recap`,
         donc les rendre est non seulement inutile, mais NUISIBLE.

         Pourquoi nuisible — défaut mesuré : les trois gabarits (coins, drapeaux,
         patchs) utilisent le MÊME nom d'hôte `.rp-actions-coins`. Rendre un
         ancien bouton à ce nom le faisait cohabiter avec le nouveau, et
         `querySelector` prend le PREMIER — donc l'ancien. Sur l'écran Patchs on
         obtenait « AJOUTER AU PANIER » avec `onclick="addCustomToCart(this)"`
         au lieu de « DEMANDER UN DEVIS » : le tap ajoutait au panier un article
         vendu sur devis, ou ne faisait rien.

         Le prix, lui, n'a pas besoin de ce mécanisme : il est retrouvé par la
         recherche à deux endroits (`.recap` PUIS `#mobile-price`, voir plus
         bas), ce qui rend la fonction idempotente sans rien déplacer en
         arrière. */
      /* Ne détruire QUE si `.recap` contient déjà un remplaçant.

         La purge s'exécute AVANT la recherche du bouton (plus bas). Détruire
         sans condition rendait donc le bouton introuvable ensuite : il n'était
         plus ni dans `.recap` (retiré au 1ᵉʳ appel) ni dans `.canvas` (détruit
         ici). Mesuré : fab=0 sur coins, drapeaux ET patchs.

         Le test « un remplaçant existe-t-il ? » tranche les deux cas :
           - changement de PRODUIT : le layout a réécrit `.recap`, un bouton neuf
             y est présent → l'ancien est obsolète, on le détruit ;
           - simple rappel de la fonction : `.recap` est vide de bouton (il a été
             déplacé) → on garde celui-ci, la recherche le retrouvera.

         C'est ce qui remplace le `data-fabHome` d'une version précédente : celui-ci
         rendait l'ancien bouton à son hôte, mais les trois gabarits partagent le
         nom `.rp-actions-coins` — l'ancien et le nouveau cohabitaient, et
         `querySelector` prenait le premier. Sur l'écran Patchs on obtenait ainsi
         « AJOUTER AU PANIER » avec `onclick="addCustomToCart(this)"` au lieu du
         bouton attendu. */
      var remplacant = recapNow && (
        recapNow.querySelector(".rp-actions-coins .rp-btn-primary") ||
        recapNow.querySelector(".rp-btn-primary") ||
        recapNow.querySelector(".rp-acts #main-add-to-cart") ||
        recapNow.querySelector(".rp-acts .btn-cart")
      );

      if (old.id === "main-add-to-cart") {
        /* Écrit en dur dans le template, jamais régénéré : on le REND à son hôte
           plutôt que de le détruire (sections/configurateur.liquid:846). */
        var hote = recapNow ? recapNow.querySelector(".rp-acts") : null;
        if (hote) hote.appendChild(old);
      } else if (remplacant && old.parentNode === canvas) {
        canvas.removeChild(old);
      }
    }

    /* Le prix du produit courant, cherché dans DEUX endroits.

       Pourquoi deux : `fillActionBar` DÉPLACE le prix de `.recap` vers
       `#mobile-price`. Ne chercher que dans `.recap` rendait la fonction non
       idempotente — or l'observer du canvas la rappelle en boucle (22 appels
       pour une seule bascule de produit, mesuré).

       Le défaut que cela provoquait : appel 1 déplace `#flags-unit-price` hors
       de `.recap` ; appel 2 ne le trouve plus, donc `price` est null et la
       branche `else` supprime le bloc — emportant le prix. Trace de
       l'instrumentation :

         « bloc prix supprimé, contenait : Total19,90 € TTC »
         #flags-unit-price final : false  ← DÉTRUIT

       Le prix des drapeaux disparaissait ainsi définitivement, et celui des
       patchs alternait entre présent et absent.

       En regardant aussi dans `#mobile-price`, un prix déjà déplacé est reconnu
       comme le prix courant : la fonction devient idempotente. Le `.recap` reste
       prioritaire, pour qu'un changement de produit prenne bien le nouveau
       gabarit ; le bloc n'est consulté qu'en second, comme mémoire de ce qu'on a
       déjà posé. */
    var boxNow = document.getElementById("mobile-price");
    var chercher = function (sel) {
      return (recapNow && recapNow.querySelector(sel))
        || (boxNow && boxNow.querySelector(sel))
        || null;
    };

    var price =
      chercher("#coins-unit-price") ||   // écran « Coins » = PATCHS
      chercher("#flags-unit-price") ||   // drapeaux
      chercher(".rp-unit-price-big") ||
      chercher(".rp-total-price") ||
      chercher("#rp-price-val");         // textile, en dernier

    var box = document.getElementById("mobile-price");

    if (price) {
      if (!box) {
        box = document.createElement("div");
        box.id = "mobile-price";
        box.className = "mobile-price";
        box.innerHTML = '<span class="mp-lbl">Total</span>';
        canvas.appendChild(box);
      } else if (box.parentNode !== canvas) {
        canvas.appendChild(box);
      }
      box.appendChild(price);
    } else if (box) {
      /* Produit SANS prix (les coins sont sur devis) : le bloc doit DISPARAÎTRE.
         Sans ce retrait il conservait l'étiquette « Total » et le montant du
         produit précédent — mesuré : 19,90 € du drapeau restait affiché sur
         l'écran coins, un prix sur un article non chiffré. */
      box.remove();
    }

    /* LA PASTILLE DE DÉLAI FLOTTANTE A ÉTÉ RETIRÉE.

       Elle vivait ici, dans le canvas, au-dessus du prix — donc PAR-DESSUS
       l'aperçu du produit, sur un écran où la place manque déjà. Le délai est
       désormais posé dans les feuilles « Taille & quantité » et « Quantité »
       (poserTailleQte / poserQuantiteSeule, plus bas), à côté du compteur qui
       le détermine pour les textiles. */
    var pastilleObsolete = document.getElementById("mobile-delai");
    if (pastilleObsolete) pastilleObsolete.remove();

    /* Bouton : produit courant d'abord, textile en dernier.

       Cherché dans `.recap` PUIS dans `.canvas`, exactement comme le prix
       ci-dessus et pour la même raison : `fillActionBar` DÉPLACE le bouton hors
       de `.recap`, et l'observer du canvas la rappelle en boucle (22 appels par
       bascule, mesuré). Ne regarder que `.recap` la rendait non idempotente — au
       2ᵉ appel le bouton n'était plus trouvable, et la purge le détruisait.

       Mesuré avant correctif :
         textile   fab=1  « Ajouter au panier »
         coins     fab=0  ← DÉTRUIT
         drapeaux  fab=0  ← DÉTRUIT
         patches   fab=0  ← DÉTRUIT

       Le textile y échappait parce que son bouton (`#main-add-to-cart`) est
       rendu à `.rp-acts` par la purge, étant écrit en dur dans le template.

       `.recap` reste PRIORITAIRE : au changement de produit, le layout y écrit
       un gabarit neuf, et c'est ce bouton-là qu'il faut prendre. `.canvas` n'est
       consulté qu'ensuite, comme mémoire de ce qui a déjà été posé. */
    var chercherBtn = function (sel) {
      return (recapNow && recapNow.querySelector(sel))
        || canvas.querySelector(sel)
        || null;
    };

    var btn =
      chercherBtn(".rp-actions-coins .rp-btn-primary") ||
      chercherBtn(".rp-btn-primary") ||
      chercherBtn(".rp-acts #main-add-to-cart") ||
      chercherBtn(".rp-acts .btn-cart") ||
      /* Déjà déplacé, le bouton textile a perdu son parent `.rp-acts` : on le
         retrouve par son id seul. Sans ce dernier recours il disparaîtrait de
         l'écran textile au 2ᵉ appel. */
      canvas.querySelector("#main-add-to-cart");

    if (btn) {
      btn.classList.add("mobile-fab");
      /* Sans bloc prix (coins, sur devis), le bouton prend toute la largeur :
         réserver la place d'un montant absent laisserait un vide à gauche. */
      btn.classList.toggle("mobile-fab-solo", !price);
      canvas.appendChild(btn);
    }

    poserTailleQte(canvas, recapNow);
    /* Les produits sans taille — coins, drapeaux, patchs — ont malgré tout une
       quantité à régler. Les deux fonctions s'excluent d'elles-mêmes : chacune
       sort net sur le terrain de l'autre. */
    poserQuantiteSeule(canvas, recapNow);

    measureNav();
    measurePrice();
    watchPrice();
  }

  /* ── TAILLE ET QUANTITÉ — sortis du récap masqué ────────────────────────

     En mobile, `.recap` est masqué en entier (conf-mobile.css:1198) : le client
     ne pouvait NI choisir sa taille NI régler sa quantité. Le masquage est
     délibéré — le panneau mangeait un tiers de la hauteur — donc on ne le
     rétablit pas : on en SORT ces deux contrôles, comme le prix et le bouton
     d'ajout l'ont été juste au-dessus.

     LES NŒUDS SONT DÉPLACÉS, PAS DUPLIQUÉS. Même principe que pour le prix :
     dupliquer imposerait de tenir deux états synchronisés, et les gestionnaires
     inline (changeTextileQty, choisirTailleDepuisRecap) continuent de
     fonctionner sans y toucher.

     ⚠️ IDEMPOTENCE OBLIGATOIRE. `fillActionBar` est rappelée en boucle par
     l'observer du canvas — 22 fois pour une seule bascule de produit, mesuré
     (voir le commentaire du prix, :411). Une fonction qui déplace un nœud sans
     le retrouver ensuite le DÉTRUIT au deuxième appel. On cherche donc, comme
     le prix, dans `.recap` PUIS dans la feuille déjà posée. */
  /* REND LE DÉLAI AU RÉCAP AVANT DE SUPPRIMER UNE FEUILLE.

     Le nœud du délai est DÉPLACÉ dans la feuille, pas cloné : supprimer
     celle-ci sans l'en sortir le détruirait, et le récapitulatif du bureau
     resterait définitivement sans délai — un `display:none` ne le ramène pas.

     C'est le défaut que ce fichier documente déjà pour les autres nœuds
     déplacés (« un nœud déplacé puis introuvable est détruit »). On le prévient
     partout où une feuille disparaît : changement de produit, mode groupe,
     écran de choix. */
  function rendreDelaiAuRecap(feuille) {
    if (!feuille) return;
    var delai = feuille.querySelector(".rp-delai");
    if (!delai) return;
    var recap = document.querySelector(".recap");
    if (!recap) { delai.remove(); return; }
    /* Devant les boutons d'action, comme dans les deux gabarits d'origine. */
    var acts = recap.querySelector(".rp-acts, .rp-actions-coins");
    if (acts) recap.insertBefore(delai, acts);
    else recap.appendChild(delai);
  }

  function poserTailleQte(canvas, recapNow) {
    if (!canvas) return;

    var feuille = document.getElementById("mob-tq-sheet");

    /* Cherché dans le récap d'abord — au changement de produit le layout y
       écrit un gabarit neuf — puis dans la feuille, mémoire de ce qu'on a
       déjà déplacé. */
    var trouver = function (sel) {
      return (recapNow && recapNow.querySelector(sel)) ||
             (feuille && feuille.querySelector(sel)) ||
             null;
    };

    var grille = trouver(".rp-tq");
    var repartir = trouver(".rp-multi-btn");

    /* PRODUIT SANS TAILLE — coins, drapeaux, patchs.

       Ils n'ont ni sélecteur de taille ni ce compteur : la grille est absente
       de leur gabarit. Le bouton et la feuille doivent disparaître, sinon ils
       garderaient ceux du produit précédent — exactement le défaut que le bloc
       prix documente plus haut (« 19,90 € du drapeau restait affiché sur
       l'écran coins »).

       ⚠️ LE PRODUIT SE JUGE SUR LE RÉCAPITULATIF, PAS SUR `trouver`.

       `trouver` regarde le récap PUIS la feuille déjà posée — c'est ce qui rend
       le déplacement idempotent. Mais pour DÉCIDER si l'écran est textile,
       cette seconde source ment : la feuille garde la grille du textile
       précédent, si bien qu'un écran de coins la trouvait encore et sautait
       cette suppression. Le bouton « Taille & quantité » survivait alors
       derrière celui de la quantité — deux boutons superposés.

       On interroge donc le RÉCAPITULATIF — mais sur un nœud QUI NE BOUGE PAS.

       `.rp-tq` ne convient pas : cette fonction le déplace elle-même dans la
       feuille quelques lignes plus bas. Au second appel — et il y en a 22 par
       bascule — le récap ne le contient plus, et elle concluait « pas un
       textile » sur un sweatshirt : son propre bouton disparaissait.

       `#rp-qty-textile` est le CONTENEUR de cette grille : il reste en place,
       seul son contenu voyage. Il dit donc de façon stable que le
       récapitulatif affiché est celui d'un textile.

       `recapNow` absent — cas théorique, `.recap` étant dans le markup — on
       s'abstient de conclure : mieux vaut laisser le bouton en place que le
       retirer sur un écran textile parce qu'on n'a rien pu lire. */
    if (recapNow && !recapNow.querySelector("#rp-qty-textile")) {
      var bAncien = document.getElementById("mob-tq-btn");
      if (bAncien) bAncien.remove();
      if (feuille) { rendreDelaiAuRecap(feuille); feuille.remove(); }
      return;
    }

    /* MODE GROUPE : la taille se règle PAR PERSONNE à l'étape « Configurer ».
       Un réglage global n'y a pas de sens. */
    var racine = document.querySelector(".conf-app-root");
    var estGroupe = racine && racine.getAttribute("data-mode") === "groupe";

    /* ÉCRAN DE CHOIX : aucun produit n'est encore configuré.

       Le bouton s'y affichait par-dessus les deux cartes de mode — il annonce
       une taille pour un article que le client n'a pas commencé à composer.

       `data-etape="choix"` est l'attribut qui porte cet écran ; il est retiré
       dès qu'un mode est retenu (conf-main-inline.js). Même test que le saut
       de l'écran de choix pour les produits sans surnom
       (conf-sidebar-modern.js:208). */
    var surEcranChoix = racine && racine.getAttribute("data-etape") === "choix";

    if (estGroupe || surEcranChoix) {
      var bGrp = document.getElementById("mob-tq-btn");
      if (bGrp) bGrp.remove();
      if (feuille) { rendreDelaiAuRecap(feuille); feuille.remove(); }
      return;
    }

    // ── La feuille ────────────────────────────────────────────────────────
    if (!feuille) {
      feuille = document.createElement("div");
      feuille.id = "mob-tq-sheet";
      feuille.className = "mob-tq-sheet side-panel";
      /* DANS `.conf-app-root`, JAMAIS DANS `body`.

         Attachée au body, la feuille s'ouvrait réellement — `transform` et
         `visibility` s'appliquaient — mais restait INVISIBLE : elle devenait
         sœur de `.conf-app-root`, qui porte `z-index: 9999` et un fond opaque
         couvrant tout l'écran. Son `z-index: 55` était alors comparé à 9999,
         pas à ses voisins du configurateur.

         Les vrais panneaux sont rendus DANS cette racine (sidebar-modern.liquid) :
         leur z-index s'y compare entre frères. La feuille doit les rejoindre.

         Défaut déjà rencontré ici pour les modales, qui ont dû monter à 10001
         (conf-mobile.css:1553) : « la modale existait, occupait bien 390×844,
         mais restait invisible — le configurateur la recouvrait entièrement ».
         Rejoindre la racine est plus sûr que surenchérir sur les z-index. */
      var racineApp = document.querySelector(".conf-app-root");
      (racineApp || document.body).appendChild(feuille);
    }
    /* ⚠️ DÉPLACER SEULEMENT SI LE NŒUD N'EST PAS DÉJÀ LÀ.

       `appendChild` sur un nœud DÉJÀ à cette place n'est PAS neutre : la
       spécification retire puis réinsère. Le `<select>` des tailles, descendant
       de `grille`, était donc démonté et remonté à chaque passage — et tout
       navigateur ferme le menu natif d'un select détaché du DOM.

       Symptôme : le menu s'ouvrait puis se refermait aussitôt. Comme
       `fillActionBar` tourne en boucle (voir la garde de l'observateur du
       canvas), le client subissait quinze à cinquante démontages pendant qu'il
       cherchait sa taille.

       Les trois autres fonctions de placement de ce fichier testent déjà le
       parent avant de déplacer (:454, :651, :1199) ; celle-ci ne le faisait
       pas. */
    if (grille.parentNode !== feuille) feuille.appendChild(grille);
    if (repartir && repartir.parentNode !== feuille) feuille.appendChild(repartir);

    /* Le résumé de la répartition suit son bouton, comme le texte d'aide juste
       après : laissé dans le récap — masqué sur téléphone — il décrirait la
       commande en cours à un endroit que personne ne voit.

       Placé AVANT l'aide, comme sur grand écran : le résultat d'abord,
       l'explication ensuite. L'ordre des `appendChild` fait l'ordre visuel.

       Même test de parent que ses voisins : `appendChild` sur un nœud déjà en
       place le démonte et le remonte, et cette fonction tourne en boucle. */
    var resume = (recapNow && recapNow.querySelector("#rp-repartition")) ||
                 feuille.querySelector("#rp-repartition");
    if (resume && resume.parentNode !== feuille) feuille.appendChild(resume);

    /* Le texte d'aide suit le bouton : il explique la répartition par tailles
       et n'a de sens qu'à côté d'elle. Laissé dans le récap, il resterait sous
       un titre « QUANTITÉ » vidé de ses contrôles. */
    var aide = (recapNow && recapNow.querySelector(".rp-tq-aide")) ||
               feuille.querySelector(".rp-tq-aide");
    if (aide && aide.parentNode !== feuille) feuille.appendChild(aide);

    /* LE DÉLAI DE PRODUCTION SUIT LA QUANTITÉ QUI LE DÉTERMINE.

       Pour un textile il dépend du nombre de pièces (2-3 semaines jusqu'à 10,
       4 au-delà) : sa place est sous le compteur qui le fait basculer, pas
       ailleurs. Le récapitulatif du bureau, lui, est masqué sur téléphone.

       Déplacé comme les nœuds ci-dessus — même test de parent, pour la même
       raison : `appendChild` sur un nœud déjà en place le démonte et le
       remonte, et cette fonction tourne en boucle. */
    var delai = (recapNow && recapNow.querySelector("#rp-delai")) ||
                feuille.querySelector("#rp-delai");
    if (delai && delai.parentNode !== feuille) feuille.appendChild(delai);

    /* La poignée de glissement vient du système de feuilles existant : voile,
       fermeture au toucher et glisser-pour-fermer sont déjà écrits (:88). */
    if (typeof addHandle === "function") addHandle(feuille);

    /* LE SÉLECTEUR DOIT ÊTRE PEUPLÉ, sinon il ne déroule rien.

       `#rp-taille-select` est écrit VIDE dans le gabarit : ses options viennent
       de `syncSelectTaille` (conf-main-inline.js:9859), qui les lit sur les
       boutons `.sg .sb`. Or cette fonction sort sans rien faire quand ces
       boutons ne sont pas encore là (`if (!btns.length) return`), et rien ne la
       rappelle ensuite.

       Un <select> sans aucune <option> est INERTE au toucher sur mobile : le
       menu système ne s'ouvre pas. Le champ paraissait donc mort.

       On la rappelle ici, après le déplacement : elle est idempotente — elle
       réécrit `innerHTML` depuis la seule source de vérité, les boutons de
       taille. */
    if (typeof window.syncSelectTaille === "function") {
      window.syncSelectTaille();
    }

    // ── Le bouton d'état, près du prix ────────────────────────────────────
    var btn = document.getElementById("mob-tq-btn");
    if (!btn) {
      btn = document.createElement("button");
      btn.type = "button";
      btn.id = "mob-tq-btn";
      btn.className = "mob-tq-btn";
      btn.addEventListener("click", function () {
        var f = document.getElementById("mob-tq-sheet");
        if (!f) return;
        if (f.classList.contains("open")) {
          closeSheet();
        } else {
          closeAllPanels();
          f.classList.add("open");
          showScrim(true);
        }
        /* Le chevron suit l'état de la feuille : il se retourne pour montrer la
           sortie. Lu APRÈS les branches ci-dessus, donc sur l'état final —
           `closeAllPanels` peut avoir refermé d'autres feuilles au passage. */
        majChevronTailleQte();
      });
      canvas.appendChild(btn);
    } else if (btn.parentNode !== canvas) {
      canvas.appendChild(btn);
    }

    majBoutonTailleQte();
  }

  /* ══════════════════════════════════════════════════════════════════════
     QUANTITÉ SEULE — coins, drapeaux et patchs

     Ces trois produits n'ont pas de taille : le bouton « Taille & quantité »
     ci-dessus les écarte, à juste titre. Mais leur champ de QUANTITÉ vit lui
     aussi dans `.recap`, masqué en mobile (conf-mobile.css) — le client ne
     pouvait donc commander que le minimum, sans aucun moyen d'en changer.

     FONCTION DISTINCTE, ET NON UNE BRANCHE DE `poserTailleQte`.

     Celle-ci porte trois sorties précoces qui encodent des règles propres au
     TEXTILE. Y greffer une seconde famille transformerait chacune en branche
     conditionnelle — dans la fonction dont dépend le seul chemin qui marche.
     On compose plutôt qu'on ne modifie : la feuille hérite de `.side-panel`
     (position, animation, fermeture, glisser-pour-fermer) et le bouton des
     styles `.mob-tq-btn`. Rien de tout cela n'est réécrit.

     Les deux boutons NE COEXISTENT JAMAIS : les gabarits de récapitulatif sont
     mutuellement exclusifs, `.rp-tq` et les trois champs ci-dessous ne
     répondent jamais sur le même écran. Ils partagent donc la même bande.
     ══════════════════════════════════════════════════════════════════════ */

  /* Les trois champs, et le nom à afficher. Le nommage interne est INVERSÉ —
     documenté dans conf-dynamic-layout.js : `coin-qty-input` sert l'écran
     PATCHS, `coin-recap-qty-input` l'écran COINS. Se tromper afficherait
     « 50 patchs » sur un écran de coins. */
  var CHAMPS_QTE = {
    "coin-recap-qty-input": ["coin", "coins"],
    "flag-qty-input": ["drapeau", "drapeaux"],
    "coin-qty-input": ["patch", "patchs"]
  };
  var SEL_QTE = "#coin-recap-qty-input, #flag-qty-input, #coin-qty-input";

  function poserQuantiteSeule(canvas, recapNow) {
    if (!canvas) return;

    var feuille = document.getElementById("mob-q-sheet");

    /* Même motif que `poserTailleQte` : `.recap` D'ABORD — au changement de
       produit, switchLayout y écrit un gabarit neuf, c'est celui-là qu'il faut
       — puis la feuille, mémoire de ce qu'on a déjà déplacé. Sans cette
       priorité, un nœud déplacé une fois ne serait jamais remplacé. */
    var trouver = function (sel) {
      return (recapNow && recapNow.querySelector(sel)) ||
             (feuille && feuille.querySelector(sel)) ||
             null;
    };

    /* ÉCRAN TEXTILE : ce n'est pas notre affaire.

       `.rp-qty-section` existe AUSSI sur le textile (configurateur.liquid) : un
       sélecteur sur cette classe seule volerait son bloc et casserait le
       chemin qui fonctionne. On s'ancre donc sur les trois identifiants non
       textiles, et on sort net dès que la grille du textile est là.

       LE REPÈRE DOIT ÊTRE UN NŒUD QUI NE BOUGE PAS.

       Ce test portait sur `.rp-tq`. Mais `poserTailleQte` s'exécute JUSTE
       AVANT et déplace précisément cette grille dans sa propre feuille : quand
       on arrive ici, le récapitulatif textile ne la contient plus. On concluait
       donc « ce n'est pas un textile » sur un sweatshirt, et le bouton
       « 50 coins » y survivait pendant que celui des tailles disparaissait.

       `#rp-qty-textile` est le CONTENEUR de cette grille (configurateur.liquid).
       Il reste en place — seul son contenu voyage. C'est donc lui qui dit, de
       façon stable, que le récapitulatif affiché est celui d'un textile. */
    if (recapNow && recapNow.querySelector("#rp-qty-textile")) {
      var bTx = document.getElementById("mob-q-btn");
      if (bTx) bTx.remove();
      if (feuille) { rendreDelaiAuRecap(feuille); feuille.remove(); }
      return;
    }

    /* Le repli sur la feuille reste indispensable à l'idempotence : dès le
       second appel, le champ n'est PLUS dans le récap — il est ici. C'est la
       DÉCISION « écran textile » qui ne doit pas s'y fier, et elle vient
       d'être prise ci-dessus, sur le récapitulatif seul. */
    var champ = trouver(SEL_QTE);
    var bloc = champ && champ.closest(".rp-qty-section");

    /* Pas de champ de quantité isolé : rien à sortir. On retire le bouton et
       la feuille, sinon ils garderaient ceux du produit précédent — même
       raison que pour la grille textile. */
    if (!bloc) {
      var bAncien = document.getElementById("mob-q-btn");
      if (bAncien) bAncien.remove();
      if (feuille) { rendreDelaiAuRecap(feuille); feuille.remove(); }
      return;
    }

    var racine = document.querySelector(".conf-app-root");
    var surEcranChoix = racine && racine.getAttribute("data-etape") === "choix";
    /* Le mode groupe est un parcours TEXTILE : ces trois produits n'en ont
       pas. Le test est défensif — il ne coûte rien et protège d'une évolution. */
    var estGroupe = racine && racine.getAttribute("data-mode") === "groupe";

    if (surEcranChoix || estGroupe) {
      var bChoix = document.getElementById("mob-q-btn");
      if (bChoix) bChoix.remove();
      if (feuille) { rendreDelaiAuRecap(feuille); feuille.remove(); }
      return;
    }

    // ── La feuille ────────────────────────────────────────────────────────
    if (!feuille) {
      feuille = document.createElement("div");
      feuille.id = "mob-q-sheet";
      feuille.className = "mob-q-sheet side-panel";
      /* DANS `.conf-app-root`, jamais dans `body` : la racine porte un
         z-index de 9999 et un fond opaque, une feuille sœur resterait
         invisible derrière. Même raison que la feuille des tailles. */
      var racineApp = document.querySelector(".conf-app-root");
      (racineApp || document.body).appendChild(feuille);
    }

    /* ⚠️ DÉPLACER SEULEMENT SI LE NŒUD N'EST PAS DÉJÀ LÀ.

       `appendChild` sur un nœud déjà en place n'est pas neutre : la
       spécification retire puis réinsère. Ici le nœud contient un
       `<input type="number">` — le réinsérer pendant la saisie ferme le
       clavier numérique. Et `fillActionBar` tourne en boucle : 22 fois pour
       une seule bascule de produit, mesuré. */
    if (bloc.parentNode !== feuille) {
      /* L'HÔTE EST MARQUÉ AVANT LE DÉPLACEMENT.

         Au retour vers le bureau, le bloc doit regagner SA `.rp-section` — pas
         le récapitulatif, où il atterrirait après le bouton d'ajout. Le
         retrouver après coup par sa vacuité serait fragile : `:empty` échoue
         sur le moindre espace blanc. On pose donc un repère tant qu'on le
         tient encore. */
      var hote = bloc.parentNode;
      if (hote && hote.classList && hote.classList.contains("rp-section")) {
        hote.setAttribute("data-hote-qte", "1");
      }
      feuille.appendChild(bloc);
    }

    /* PURGE DES BLOCS ORPHELINS — après le déplacement, jamais avant.

       Au changement de produit, le gabarit est réécrit intégralement : un
       exemplaire neuf arrive, l'ancien resterait dans la feuille à côté du
       nouveau. Purger AVANT la recherche rendrait le nœud introuvable — c'est
       un défaut que ce fichier documente déjà ailleurs. */
    var anciens = feuille.querySelectorAll(".rp-qty-section");
    for (var i = 0; i < anciens.length; i++) {
      if (anciens[i] !== bloc) anciens[i].remove();
    }

    /* LE DÉLAI DE PRODUCTION REJOINT LA FEUILLE, comme pour les textiles.

       Ces trois produits ont un délai fixe (5 à 7 semaines), écrit en dur dans
       leur gabarit (conf-dynamic-layout.js). Ce gabarit étant réécrit à chaque
       changement de produit, un exemplaire neuf arrive à chaque fois : on
       purge les précédents ici aussi, sans quoi ils s'empileraient. */
    var delai = (recapNow && recapNow.querySelector(".rp-delai")) ||
                feuille.querySelector(".rp-delai");
    if (delai) {
      if (delai.parentNode !== feuille) feuille.appendChild(delai);
      var vieux = feuille.querySelectorAll(".rp-delai");
      for (var j = 0; j < vieux.length; j++) {
        if (vieux[j] !== delai) vieux[j].remove();
      }
    }

    if (typeof addHandle === "function") addHandle(feuille);

    // ── Le bouton d'état ──────────────────────────────────────────────────
    var btn = document.getElementById("mob-q-btn");
    if (!btn) {
      btn = document.createElement("button");
      btn.type = "button";
      btn.id = "mob-q-btn";
      /* `mob-tq-btn` en plus de sa propre classe : tout le style du bouton
         des tailles — taille, fond, ombre, chevron — s'applique sans être
         réécrit. Seule la position peut différer. */
      btn.className = "mob-tq-btn mob-q-btn";
      btn.addEventListener("click", function () {
        var f = document.getElementById("mob-q-sheet");
        if (!f) return;
        if (f.classList.contains("open")) {
          closeSheet();
        } else {
          closeAllPanels();
          f.classList.add("open");
          showScrim(true);
        }
        majChevronQuantite();
      });
      canvas.appendChild(btn);
    } else if (btn.parentNode !== canvas) {
      canvas.appendChild(btn);
    }

    majBoutonQuantite();
  }

  /** Le chevron suit l'état réel de la feuille, jamais un état mémorisé. */
  function majChevronQuantite() {
    var btn = document.getElementById("mob-q-btn");
    var f = document.getElementById("mob-q-sheet");
    if (!btn) return;
    btn.classList.toggle("is-open", !!(f && f.classList.contains("open")));
  }
  window.majChevronQuantite = majChevronQuantite;

  /* Le bouton affiche l'état COURANT : « 50 coins ». Relu depuis le champ
     lui-même, jamais mémorisé — il reste la seule source de vérité. */
  function majBoutonQuantite() {
    var btn = document.getElementById("mob-q-btn");
    if (!btn) return;

    var feuille = document.getElementById("mob-q-sheet");
    var champ = (feuille && feuille.querySelector(SEL_QTE)) ||
                document.querySelector(SEL_QTE);
    if (!champ) return;

    var n = parseInt(champ.value, 10);
    if (!isFinite(n) || n < 1) n = 1;

    var noms = CHAMPS_QTE[champ.id] || ["unité", "unités"];
    var mot = (n > 1) ? noms[1] : noms[0];

    /* LE MINIMUM N'EST PAS SUR LE BOUTON. Il est invariant — un bouton d'état
       montre ce qui change — et il figure déjà dans la feuille
       (`.rp-qty-subtitle`), à l'endroit exact où le client peut agir dessus. */
    btn.setAttribute("aria-haspopup", "dialog");
    btn.setAttribute("aria-label",
      "Quantité : " + n + " " + mot + ". Appuyez pour modifier.");

    btn.innerHTML =
      '<span class="mtq-txt">' +
        '<span class="mtq-lbl">Quantité</span>' +
        '<span class="mtq-val">' + n +
          '<span class="mtq-sep"> </span>' +
          '<span class="mtq-x">' + mot + "</span>" +
        "</span>" +
      "</span>" +
      '<svg class="mtq-caret" viewBox="0 0 24 24" fill="none" ' +
      'stroke="currentColor" stroke-width="2.6" stroke-linecap="round" ' +
      'stroke-linejoin="round" aria-hidden="true">' +
      '<polyline points="6 15 12 9 18 15"/></svg>';
  }
  window.majBoutonQuantite = majBoutonQuantite;

  /* LE BOUTON SUIT LA VALEUR, PAR TROIS CHEMINS.

     `input` et `change` couvrent la saisie au clavier. Mais les boutons − et +
     écrivent `input.value` PAR PROGRAMME (changeCoinRecapQty et consorts), ce
     qui ne déclenche NI l'un NI l'autre : sans le troisième écouteur, le
     bouton afficherait une valeur périmée après chaque appui.

     Délégation sur `document` : les nœuds sont déplacés hors du récap, un
     écouteur posé sur eux ne survivrait pas au changement de produit. */
  ["input", "change"].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      if (e.target && CHAMPS_QTE[e.target.id]) majBoutonQuantite();
    });
  });
  document.addEventListener("click", function (e) {
    var b = e.target && e.target.closest && e.target.closest(".rp-qty-btn");
    if (!b) return;
    /* Après le gestionnaire inline du bouton, qui vient d'écrire la valeur. */
    requestAnimationFrame(majBoutonQuantite);
  });

  /* Le chevron suit l'ÉTAT RÉEL de la feuille, jamais un état mémorisé.

     Elle se referme par plusieurs chemins — le bouton, le voile, une autre
     feuille qui s'ouvre : suivre chacun d'eux aurait laissé le chevron à
     l'envers le jour où l'on en ajoute un. On relit la feuille, qui fait foi. */
  function majChevronTailleQte() {
    var btn = document.getElementById("mob-tq-btn");
    var f = document.getElementById("mob-tq-sheet");
    if (!btn) return;
    btn.classList.toggle("is-open", !!(f && f.classList.contains("open")));
  }
  window.majChevronTailleQte = majChevronTailleQte;

  /* Le bouton affiche l'état COURANT : « M · Qté 1 ». Relu depuis les nœuds
     eux-mêmes, jamais mémorisé — ils restent la seule source de vérité. */
  function majBoutonTailleQte() {
    var btn = document.getElementById("mob-tq-btn");
    if (!btn) return;

    var sel = document.getElementById("rp-taille-select");
    var qte = document.getElementById("textile-qty-input");

    var taille = (sel && sel.value) || "";
    var n = (qte && parseInt(qte.value, 10)) || 1;

    /* UN CHEVRON DIT QUE ÇA S'OUVRE.

       Le bouton n'affichait que « Taille M » : il se lisait comme une étiquette
       d'information, pas comme une commande. Le client ne savait pas qu'il
       pouvait changer sa taille ni sa quantité — les deux seuls réglages de
       l'article, et ils n'existaient nulle part ailleurs sur mobile.

       Chevron VERS LE HAUT, et non le bas : la feuille monte depuis le bas de
       l'écran. C'est la convention iOS, et elle annonce le sens du geste autant
       que sa possibilité.

       `aria-haspopup` et `aria-label` portent la même information pour un
       lecteur d'écran, qui ne voit pas le chevron. */
    btn.setAttribute("aria-haspopup", "dialog");
    btn.setAttribute(
      "aria-label",
      "Taille et quantité : " + (taille || "taille non choisie") +
        ", " + n + (n > 1 ? " articles" : " article") +
        ". Appuyez pour modifier."
    );

    /* LE LIBELLÉ NOMME TOUT CE QUI SE RÈGLE ICI.

       Il disait « Taille », alors que la feuille porte aussi la QUANTITÉ et la
       répartition par tailles. Le client cherchant à commander trois pièces
       n'avait aucune raison d'ouvrir un bouton qui n'annonçait qu'une taille.

       LA QUANTITÉ EST TOUJOURS ÉCRITE, même à 1. Elle n'apparaissait qu'au-delà
       — donc jamais au moment où le client se demande justement où la changer.
       « M · 1 article » se lit comme un état complet ; « M » seul se lit comme
       une étiquette. */
    var motArticle = (n > 1) ? " articles" : " article";

    /* `mtq-txt` empile le libellé et la valeur ; le chevron reste son voisin
       sur la même ligne (conf-mobile.css). */
    btn.innerHTML =
      '<span class="mtq-txt">' +
        '<span class="mtq-lbl">Taille &amp; quantité</span>' +
        '<span class="mtq-val">' + (taille || "—") +
          '<span class="mtq-sep"> · </span>' +
          '<span class="mtq-x">' + n + motArticle + "</span>" +
        "</span>" +
      "</span>" +
      '<svg class="mtq-caret" viewBox="0 0 24 24" fill="none" ' +
      'stroke="currentColor" stroke-width="2.6" stroke-linecap="round" ' +
      'stroke-linejoin="round" aria-hidden="true">' +
      '<polyline points="6 15 12 9 18 15"/></svg>';
  }
  window.majBoutonTailleQte = majBoutonTailleQte;

  /* Le bouton suit les changements SANS toucher aux fonctions du configurateur.

     On écoute les nœuds plutôt que d'instrumenter `changeTextileQty`,
     `handleTextileQtyInput` et `choisirTailleDepuisRecap` : un seul endroit à
     tenir, et les chemins de mise à jour qu'on n'aurait pas repérés sont
     couverts aussi. `input` attrape le clavier, `change` les boutons − / + qui
     écrivent la valeur par programme.

     Délégation sur `document` : les nœuds sont DÉPLACÉS dans la feuille, un
     écouteur posé sur eux directement survivrait mais serait à reposer à chaque
     recréation. */
  document.addEventListener("input", function (e) {
    if (!e.target) return;
    if (e.target.id === "textile-qty-input" || e.target.id === "rp-taille-select") {
      majBoutonTailleQte();
    }
  });
  document.addEventListener("change", function (e) {
    if (!e.target) return;
    if (e.target.id === "textile-qty-input" || e.target.id === "rp-taille-select") {
      majBoutonTailleQte();
    }
  });

  /* « Répartir par tailles » ouvre une MODALE PLEIN ÉCRAN
     (conf-mobile.css:1206). La feuille doit se retirer avant, sinon deux
     couches se superposent et le voile de l'une reste sous l'autre.

     En phase de CAPTURE : le clic doit être traité avant le gestionnaire
     inline du bouton, qui ouvre la modale. */
  document.addEventListener("click", function (e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest(".rp-multi-btn")) {
      var f = document.getElementById("mob-tq-sheet");
      if (f && f.classList.contains("open")) closeSheet();
    }
  }, true);

  /* Largeur du bloc prix, posé PAR-DESSUS le bouton d'ajout (les deux sont
     ancrés à gauche). Le bouton s'en sert comme marge pour que son libellé
     ne passe pas dessous.

     Mesurée plutôt que codée en dur : « 9,90 € » et « 1 250,00 € »
     n'occupent pas la même place, et le montant change à chaque option. */
  function measurePrice() {
    var box = document.getElementById("mobile-price");
    if (!box) return;
    if (!isMobile()) {
      document.documentElement.style.removeProperty("--mp-w");
      return;
    }
    var w = box.getBoundingClientRect().width;
    if (w) {
      document.documentElement.style.setProperty(
        "--mp-w",
        Math.ceil(w) + "px",
      );
    }
  }

  /* Le montant change à chaque option (couleur, taille, manches, quantité) :
     sa largeur aussi. On remesure pour que la marge du bouton suive. */
  function watchPrice() {
    var box = document.getElementById("mobile-price");
    if (!box || box.dataset.widthWatched === "1") return;

    box.dataset.widthWatched = "1";
    new MutationObserver(function () {
      requestAnimationFrame(measurePrice);
    }).observe(box, { childList: true, characterData: true, subtree: true });

    window.addEventListener("resize", measurePrice);
  }

  /* Le récap est réécrit par le layout dynamique : on replace nos nœuds
     dès que son contenu change. */
  function observeRecap() {
    var recap = document.querySelector(".recap");
    if (!recap) return;
    var obs = new MutationObserver(function () {
      /* Ignorer NOS PROPRES écritures. `fillActionBar` rend `#main-add-to-cart`
         à `.rp-acts`, donc dans `.recap` — le nœud même qu'on observe ici.

         Le verrou `_fabEnCours` ne suffit pas : les MutationObserver sont
         notifiés en microtâche, donc après que le verrou soit relâché. Sans ce
         filtre, chaque exécution se redéclenche et l'onglet plante (mesuré :
         3004 mutations en 3 s).

         250 ms couvre le lot de mutations d'un même appel — `fillActionBar`
         déplace 2 ou 3 nœuds, tout est livré dans la même tâche. Une vraie
         réécriture du récap par le layout dynamique arrive sur action
         utilisateur (changement de produit, de quantité), jamais dans les
         250 ms qui suivent notre propre écriture : elle n'est donc pas
         masquée. */
      if (Date.now() - _fabDerniereEcriture < 250) return;
      if (isMobile()) fillActionBar();
    });
    obs.observe(recap, { childList: true, subtree: true });
  }

  /* L'ÉTAPE ET LE MODE VIVENT SUR LA RACINE, PAS DANS LE RÉCAP.

     `poserTailleQte` retire le bouton « Taille & quantité » à l'écran de choix
     et en mode groupe — deux états portés par `data-etape` et `data-mode` sur
     `.conf-app-root`.

     Mais elle n'était rappelée que par l'observateur du récap ci-dessus. Revenir
     à l'écran de choix ne touche pas au récap : personne ne la relançait, et le
     bouton restait affiché par-dessus les deux cartes de mode — annonçant une
     taille pour un article que le client n'a pas commencé à composer.

     On observe donc les attributs qui portent réellement ces états. Le filtre
     `attributeFilter` limite les notifications aux deux qui nous concernent :
     la racine en porte d'autres, changés bien plus souvent. */
  function observeEtapeMode() {
    var racine = document.querySelector(".conf-app-root");
    if (!racine) return;
    new MutationObserver(function () {
      if (isMobile()) fillActionBar();
    }).observe(racine, {
      attributes: true,
      attributeFilter: ["data-etape", "data-mode", "data-etape-groupe"]
    });
  }

  /* Retour en desktop : le prix et le bouton doivent regagner le récap,
     sinon ils resteraient coincés dans le header — où le CSS desktop ne
     les attend pas (et où le récap, redevenu visible, les afficherait en
     double s'ils avaient été clonés ; ils ne le sont pas, ils manqueraient
     donc simplement à leur place). */
  function removeActionBar() {
    var recap = document.querySelector(".recap");
    if (!recap) return;

    /* On récupère les éléments DÉPLACÉS, pas ceux du textile : fillActionBar
       sort le prix et le bouton du produit courant, qui peut être un patch, un
       drapeau ou un coin. Ne chercher que #rp-price-val / #main-add-to-cart
       laissait ces trois-là coincés hors du récap au retour en desktop. */
    var canvasNow = document.querySelector(".canvas");
    var price = document.getElementById("mobile-price");
    price = price ? price.querySelector(".rp-unit-price-big, #rp-price-val, [id$='-unit-price']") : null;
    var btn = canvasNow ? canvasNow.querySelector(".mobile-fab") : null;

    var priceHost = recap.querySelector(".rp-price, .rp-total-section, .rp-section");
    var actsHost = recap.querySelector(".rp-acts, .rp-actions-coins");

    if (price && priceHost && price.parentNode !== priceHost) {
      priceHost.appendChild(price);
    }
    if (btn && actsHost && btn.parentNode !== actsHost) {
      // Ces classes portent toute la mise en forme flottante : elles doivent partir.
      btn.classList.remove("mobile-fab", "mobile-fab-solo");
      actsHost.appendChild(btn);
    }

    // L'étiquette « Total » n'a plus d'objet une fois le prix reparti.
    var box = document.getElementById("mobile-price");
    if (box) box.remove();

    /* TAILLE ET QUANTITÉ RENDUES AU RÉCAP.

       Elles ont été déplacées dans une feuille attachée au `body`
       (poserTailleQte) : sans ce retour, elles resteraient ORPHELINES au
       redimensionnement vers le bureau — le panneau latéral s'afficherait sans
       sélecteur de taille ni compteur de quantité, et le client ne pourrait
       plus commander.

       Même principe que le prix et le bouton juste au-dessus : on rend les
       nœuds à leur hôte d'origine, puis on retire les conteneurs mobiles. */
    var feuilleTQ = document.getElementById("mob-tq-sheet");
    if (feuilleTQ) {
      var grilleTQ = feuilleTQ.querySelector(".rp-tq");
      var repartirTQ = feuilleTQ.querySelector(".rp-multi-btn");
      /* L'hôte est `.rp-qty-section` (dans `#rp-qty-textile`), PAS le récap
         lui-même : rendus à la racine du panneau, ils atterriraient après le
         prix et le bouton d'ajout, sous le titre « QUANTITÉ » resté seul.

         L'ordre compte aussi — la grille précède « Répartir par tailles ». */
      var hoteTQ = recap.querySelector("#rp-qty-textile .rp-qty-section") ||
                   recap.querySelector(".rp-qty-section");
      var aideTQ = feuilleTQ.querySelector(".rp-tq-aide");
      /* Le résumé de la répartition fait le chemin inverse lui aussi : oublié
         ici, il resterait prisonnier de la feuille mobile après un retour sur
         grand écran, et le panneau n'annoncerait plus la commande composée. */
      var resumeTQ = feuilleTQ.querySelector("#rp-repartition");
      if (hoteTQ) {
        if (grilleTQ) hoteTQ.appendChild(grilleTQ);
        if (repartirTQ) hoteTQ.appendChild(repartirTQ);
        /* Même ordre qu'au départ : le résultat, puis l'explication. */
        if (resumeTQ) hoteTQ.appendChild(resumeTQ);
        if (aideTQ) hoteTQ.appendChild(aideTQ);
      }
      /* Le délai retourne au RÉCAP, pas dans `.rp-qty-section` : sur ordinateur
         sa place est entre le prix et le bouton d'ajout, là où le markup le
         pose (configurateur.liquid). Rendu à la section quantité, il
         remonterait au-dessus du prix. */
      var delaiTQ = feuilleTQ.querySelector("#rp-delai");
      if (delaiTQ) {
        var actsTQ = recap.querySelector(".rp-acts");
        if (actsTQ) recap.insertBefore(delaiTQ, actsTQ);
        else recap.appendChild(delaiTQ);
      }
      feuilleTQ.remove();
    }
    var btnTQ = document.getElementById("mob-tq-btn");
    if (btnTQ) btnTQ.remove();

    /* MÊME RETOUR POUR LA QUANTITÉ DES NON-TEXTILES.

       Sans ce bloc, un passage mobile → bureau laisserait coins, drapeaux et
       patchs SANS champ de quantité dans le récapitulatif redevenu visible :
       le nœud resterait orphelin dans une feuille supprimée, et le client ne
       pourrait plus rien commander d'autre que le minimum. Régression grave, et
       silencieuse.

       L'hôte a été MARQUÉ au moment du déplacement (`data-hote-qte`) : le
       retrouver après coup par sa vacuité serait fragile, `:empty` échouant sur
       le moindre espace blanc. */
    var feuilleQ = document.getElementById("mob-q-sheet");
    if (feuilleQ) {
      var blocQ = feuilleQ.querySelector(".rp-qty-section");
      if (blocQ) {
        var hoteQ = recap.querySelector(".rp-section[data-hote-qte]");
        if (hoteQ) {
          hoteQ.appendChild(blocQ);
          hoteQ.removeAttribute("data-hote-qte");
        }
      }
      /* Le délai reprend sa place devant les boutons d'action, comme dans le
         gabarit d'origine (conf-dynamic-layout.js). */
      var delaiQ = feuilleQ.querySelector(".rp-delai");
      if (delaiQ) {
        var actsQ = recap.querySelector(".rp-actions-coins");
        if (actsQ) recap.insertBefore(delaiQ, actsQ);
        else recap.appendChild(delaiQ);
      }
      feuilleQ.remove();
    }
    var btnQ = document.getElementById("mob-q-btn");
    if (btnQ) btnQ.remove();

    document.documentElement.style.removeProperty("--nav-h");
    document.documentElement.style.removeProperty("--mp-w");
  }

  /* ── Zones : aucune intervention JS ─────────────────────────────────
     Le mobile reproduit la géométrie desktop en CSS — image en `height`
     viewport + `width: auto`, layer en `inset: 0` sur le conteneur — donc
     les zones de buildZones() tombent au même endroit des deux côtés.

     Cette fonction ne fait plus qu'EFFACER les styles inline qu'écrivaient
     les versions antérieures : plus prioritaires que le CSS, ils
     maintiendraient sinon l'ancien calage sur l'image dessinée.

     Elle reste appelée depuis watchImages() : point d'accroche si un
     recalage redevient nécessaire. */
  /* Cale #logo-layer sur l'IMAGE RÉELLEMENT DESSINÉE.

     C'est le référentiel le plus stable : il ne dépend ni de la taille de
     la fenêtre, ni du padding du conteneur. Une zone à 50 % y signifie
     toujours « la moitié de la largeur de l'image », sur tout écran.

     Le desktop, lui, laisse le layer couvrir le conteneur (inset: 0) où
     l'image flotte avec des marges variables. Les deux référentiels sont
     donc différents, et les zones mobile ont leurs PROPRES valeurs (voir
     CHEST_MOBILE / BACK_MOBILE) — aucune conversion entre les deux : les
     tentatives précédentes de faire coïncider les pourcentages ont toutes
     échoué, parce que le rapport image/conteneur du desktop n'est pas une
     constante. */
  function syncLayerToImage() {
    var layer = document.getElementById("logo-layer");
    if (!layer) return;

    /* Hors mobile : on rend la main au CSS — mais SEULEMENT si c'est nous
       qui avions posé le calage.

       conf-tablet.js fait le même travail sur le même élément, et ses
       observateurs comme les nôtres tournent en permanence. Sans ce
       marqueur, chacun effacerait les styles de l'autre. */
    if (!isMobile()) {
      if (layer.dataset.layerOwner === "mobile") {
        layer.style.left = "";
        layer.style.top = "";
        layer.style.width = "";
        layer.style.height = "";
        delete layer.dataset.layerOwner;
      }
      return;
    }

    var img = document.querySelector(".product-img-single.on");
    var host = document.querySelector(".cv-single-view");
    if (!img || !host) return;
    if (!img.naturalWidth || !img.naturalHeight) return;

    /* Dimensions de MISE EN PAGE (offset*), et non getBoundingClientRect().

       Le zoom (autoZoomTo, conf-main-inline.js) pose un `transform: scale()`
       sur .cv-single-view. getBoundingClientRect() renvoie la boîte APRÈS
       transformation : à 200 %, l'image était mesurée deux fois trop grande.
       Or #logo-layer est ENFANT de .cv-single-view — il subit déjà ce même
       scale. Écrire ces pixels agrandis le rendait donc doublement zoomé, et
       les zones (manches en particulier) étaient projetées hors du visuel :
       elles disparaissaient de l'écran dès que la vue se rapprochait.

       offsetWidth/offsetHeight ignorent les transforms : ils décrivent la
       géométrie non zoomée, exactement le référentiel dans lequel le layer
       est positionné. Le zoom s'applique ensuite aux deux de la même façon,
       et le calage reste juste à tout niveau. */
    var hostW = host.offsetWidth;
    var hostH = host.offsetHeight;
    var imgW = img.offsetWidth;
    var imgH = img.offsetHeight;
    if (!hostW || !hostH || !imgW || !imgH) return;

    /* Rectangle du PIXEL VISIBLE : `object-fit: contain` conserve le ratio,
       le reste de la boîte <img> est du vide. */
    var scale = Math.min(imgW / img.naturalWidth, imgH / img.naturalHeight);
    var drawnW = img.naturalWidth * scale;
    var drawnH = img.naturalHeight * scale;

    /* Position de l'image dans le conteneur, elle aussi hors transform :
       offsetLeft/offsetTop sont relatifs au parent positionné (.cv-single-view). */
    layer.dataset.layerOwner = "mobile";   // voir la branche hors-mobile

    var next = {
      left: Math.round(img.offsetLeft + (imgW - drawnW) / 2) + "px",
      top: Math.round(img.offsetTop + (imgH - drawnH) / 2) + "px",
      width: Math.round(drawnW) + "px",
      height: Math.round(drawnH) + "px",
    };

    /* N'écrire QUE si la valeur change. #logo-layer est dans le sous-arbre
       observé par watchImages(), et l'attribut `style` en fait partie : une
       réécriture — même à l'identique — déclenche une mutation, donc un
       nouveau syncLayerToImage. La boucle était amortie par
       requestAnimationFrame (une passe par frame, jamais infinie) mais
       tournait en continu à 60 fps sans rien changer. */
    Object.keys(next).forEach(function (k) {
      if (layer.style[k] !== next[k]) layer.style[k] = next[k];
    });

    /* Les zones sont recalculées même sans changement de géométrie : un
       changement de VUE (data-view / data-side) ne déplace pas le calque
       mais change les zones à afficher. */
    applyMobileZones();
  }
  // Exposée : utile au débogage et si un autre script change de vue.
  window.syncLayerToImage = syncLayerToImage;

  /* Le recalage doit suivre TOUS les changements d'image : changement de
     vue (face/dos/côté), de produit, de couleur — chacun remplace le src ou
     bascule la classe .on. On observe donc les <img> plutôt que d'essayer
     de se brancher sur chaque fonction appelante. */
  function watchImages() {
    var host = document.querySelector(".cv-single-view");
    if (!host) return;

    /* Les CALQUES DÉPLAÇABLES sont ignorés — sans quoi cet observateur se
       déclenche sur le glisser-déposer lui-même.

       `subtree: true` + `style` capte TOUT changement de style sous
       .cv-single-view, y compris chaque `style.left` qu'écrit un déplacement au
       doigt. La chaîne qui suit — syncLayerToImage → applyMobileZones →
       reflowLogos → placeLogoInZone / clampTextToZone — REPOSITIONNE alors
       l'élément : le logo ou le texte revenait à sa place de départ dès que le
       client relâchait.

       Le verrou __logoManipulating ne suffisait pas : il est levé de façon
       SYNCHRONE à touchend (conf-logo-drag.js:849), alors qu'un
       MutationObserver livre ses mutations de façon asynchrone. Quand celles
       accumulées pendant le geste arrivaient enfin, le verrou était déjà
       retombé et le garde de reflowLogos (:1315) laissait passer.

       On filtre donc à la source : cet observateur ne surveille que les IMAGES
       PRODUIT (voir le commentaire ci-dessus), un calque n'a jamais eu à le
       réveiller. Correction indépendante de tout verrou et de tout délai. */
    var obs = new MutationObserver(function (mutations) {
      var pertinent = mutations.some(function (m) {
        var t = m.target;
        /* `closest` n'existe que sur un Element : une mutation peut viser un
           nœud texte. Dans le doute, on considère la mutation pertinente —
           mieux vaut un recalage de trop qu'un calque désaligné. */
        if (!t || typeof t.closest !== 'function') return true;
        return !t.closest('.design-logo, .design-text');
      });
      if (!pertinent) return;

      // L'image change : on attend qu'elle soit décodée pour mesurer.
      requestAnimationFrame(syncLayerToImage);
    });
    /* `data-view` / `data-side` sont indispensables : le changement de VUE
       (face/dos/côté) et la bascule manche gauche/droite ne passent que par
       ces attributs, posés sur #logo-layer par conf-view-switcher.js et
       conf-sleeve-side.js. Sans eux, syncLayerToImage() — et donc
       applyMobileZones(), qui recalcule les zones — n'était jamais rejouée
       au passage sur une manche : les zones gardaient les valeurs de la vue
       précédente et tombaient hors du visuel. */
    obs.observe(host, {
      attributes: true,
      attributeFilter: ["class", "src", "style", "data-view", "data-side"],
      subtree: true,
    });

    // Un src fraîchement posé n'a ses dimensions qu'au load.
    document.querySelectorAll(".product-img-single").forEach(function (im) {
      im.addEventListener("load", syncLayerToImage);
    });

    window.addEventListener("resize", function () {
      measureNav();
      syncLayerToImage();
    });
    window.addEventListener("orientationchange", function () {
      setTimeout(function () {
        measureNav();
        syncLayerToImage();
      }, 250);
    });
  }

  /* La barre d'options change de hauteur quand une catégorie ajoute son
     bouton (Options Coin / Drapeau / Patch) : refreshCategoryUI() bascule
     leur `display`. On remesure alors, et on recale les zones — la place
     disponible pour le produit vient de changer. */
  function watchNav() {
    var nav = document.querySelector(".icon-nav");
    if (!nav) return;
    var obs = new MutationObserver(function () {
      measureNav();
      requestAnimationFrame(syncLayerToImage);
    });
    obs.observe(nav, {
      attributes: true,
      attributeFilter: ["style", "class"],
      subtree: true,
    });
  }

  /* ── Fermeture après le choix d'un produit ──────────────────────────
     Le choix fait, la feuille n'a plus de raison de masquer l'aperçu : on
     la referme pour montrer le résultat.

     Écouté ici plutôt que dans selectProduct() — cette fonction est
     partagée avec le desktop, où la sidebar doit au contraire rester
     ouverte en permanence.

     En BULLE (pas en capture) : le handler d'origine s'exécute d'abord,
     le produit est donc déjà changé quand on ferme. Le petit délai laisse
     voir la coche de sélection avant que la feuille ne descende.         */

  function onPanelSelect(e) {
    if (!isMobile()) return;
    var t = e.target;
    if (!t || !t.closest) return;

    // Uniquement depuis une feuille ouverte.
    if (!t.closest(".side-panel.open")) return;

    // Le choix d'un PRODUIT ferme la feuille : c'est une action terminale.
    // Couleur et taille ne la ferment pas — on en essaie souvent plusieurs
    // à la suite, et le résultat se voit derrière la feuille.
    if (t.closest(".product-card")) {
      setTimeout(closeSheet, 180);
      return;
    }

    /* « Ajouter au design » (texte) : action terminale elle aussi. En
       desktop le panneau reste ouvert volontairement — le client enchaîne
       souvent sur un second texte (voir addTextToDesign) — mais en mobile
       la feuille COUVRE le produit : sans fermeture, il ne voit pas ce
       qu'il vient de poser.

       Le délai laisse le texte s'insérer avant que la feuille ne descende ;
       le zoom suit, pour que le résultat soit lisible sur petit écran. */
    if (t.closest("#mtxt-add-btn")) {
      setTimeout(function () {
        closeSheet();
        /* PAS de zoom automatique ici : il applique un `transform: scale()`
           animé sur .cv-single-view, et toute mesure prise pendant
           l'animation (clampTextToZone) place le texte à côté de sa zone.
           Le client zoome lui-même s'il le souhaite.
           On replace le texte une fois la feuille refermée. */
        setTimeout(reflowTexts, 260);
      }, 200);
    }
  }

  /* Upload d'image : la feuille se referme dès qu'un fichier est retenu.

     On écoute le `change` des <input type="file"> plutôt que le clic sur le
     bouton : le client peut ouvrir le sélecteur puis annuler, auquel cas
     rien ne doit bouger. Le zoom est déjà déclenché par doUpload().

     Le délai couvre la fenêtre de suppression d'arrière-plan, qui s'ouvre
     par-dessus : fermer avant elle la ferait disparaître avec la feuille. */
  function watchUploads() {
    document
      .querySelectorAll('#conf-app-root input[type="file"], input[type="file"]')
      .forEach(function (inp) {
        inp.addEventListener("change", function () {
          if (!isMobile()) return;
          if (!inp.files || !inp.files.length) return;
          setTimeout(closeSheet, 400);
        });
      });
  }

  /* Drapeau FR : la feuille se referme dès qu'il est posé.

     Même intention que l'upload ci-dessus — le geste est terminé, le client
     veut voir son visuel sur le vêtement, or la feuille le recouvre. Ici pas
     de sélecteur de fichier à annuler : le drapeau est appliqué au clic, on
     peut donc écouter le bouton directement.

     Écouteur DÉLÉGUÉ sur le document : le bouton vit dans la sidebar, dont le
     contenu est reconstruit au changement de produit — un écouteur posé sur
     l'élément lui-même serait perdu. Le délai laisse addFrenchFlag() poser le
     visuel et déclencher son zoom avant que la feuille ne descende. */
  var flagFrWatched = false;
  function watchFlagFr() {
    /* init() peut être rejouée (panneaux pas encore présents au premier
       passage) : sans ce drapeau, les écouteurs s'empileraient et closeSheet
       serait programmée plusieurs fois. Même précaution que watchZoomEnd. */
    if (flagFrWatched) return;
    flagFrWatched = true;
    document.addEventListener("click", function (e) {
      if (!isMobile()) return;
      var btn = e.target.closest && e.target.closest("#upload-flag-fr");
      if (!btn) return;
      setTimeout(closeSheet, 300);
    });
  }

  /* ── Bascule RECTO / VERSO (drapeaux, coins, patchs) ────────────────
     Ces produits posent leurs deux faces côte à côte. Sur une largeur de
     téléphone, chacune devient minuscule et déborde. On n'en montre donc
     qu'une, sélectionnée par une bascule placée en haut de l'aperçu.

     Le masquage est fait en CSS, piloté par l'attribut `data-face-active`
     sur la scène — aucun style inline sur les faces, donc rien n'entre en
     conflit avec le code produit qui les manipule déjà.                  */

  /* ── Nature du canvas courant ───────────────────────────────────────
     .cv-canvas-row héberge deux structures incompatibles : le textile (une
     image en absolu qui couvre la ligne) et les autres produits (une scène
     enfant flex). Le CSS a besoin de les distinguer ; on le lui dit via un
     attribut plutôt que par :has(), dont on ne veut pas dépendre.         */

  function tagCanvasRow() {
    var row = document.querySelector(".cv-canvas-row");
    if (!row) return;
    row.setAttribute(
      "data-canvas",
      row.querySelector(".cv-single-view") ? "single" : "stage",
    );
  }

  /* ── « Vue d'ensemble » hors de la colonne des vues ─────────────────
     Ce bouton n'est pas une vue de plus : c'est une synthèse, et il ouvre
     une modale. Il doit se poser en haut à droite, sous le header.

     Le CSS seul n'y suffit pas : .vtabs est `position: absolute`, donc un
     enfant en `absolute` s'ancre sur ELLE et reste collé à la colonne. On
     le sort donc du DOM de .vtabs pour le rattacher à .canvas, qui couvre
     tout l'aperçu.

     Le nœud est DÉPLACÉ, pas recréé : son `onclick="showOverview()"` et son
     id restent intacts.                                                   */

  function moveOverviewBtn() {
    var btn = document.getElementById("overview-btn");
    var canvas = document.querySelector(".canvas");
    if (!btn || !canvas) return;

    if (isMobile()) {
      /* Placé DANS .cv-opts, à côté des pastilles Couleur/Taille : les trois
         deviennent des enfants du même conteneur flex, donc alignés par
         construction.

         Auparavant le bouton était posé en absolu dans .canvas, avec le même
         `top: 8px` que .cv-opts — mais les deux ne partagent pas exactement
         la même origine (les pastilles vivent dans .cv-hdr, dans le flux),
         et il retombait quelques pixels plus haut. */
      /* #cv-opts (pastilles Couleur/Taille) n'existe QUE pour le textile :
         conf-dynamic-layout.js réécrit le canvas des coins / drapeaux /
         patchs avec un header `.cv-hdr-row` qui n'en contient pas. Le repli
         sur .canvas posait alors le bouton en bas de l'aperçu, très loin de
         la bascule Recto/Verso avec laquelle il doit s'aligner.

         Pour ces produits on vise donc .cv-wrap — le référent positionné de
         l'aperçu, celui-là même où buildFaceSwitch() ancre la bascule. Les
         deux partagent ainsi la même origine et le même `top`, sans avoir à
         mesurer quoi que ce soit. */
      var opts = document.getElementById("cv-opts");
      var host = opts || document.querySelector(".cv-wrap") || canvas;
      if (btn.parentNode !== host) host.appendChild(btn);
      /* Marqueur lu par le CSS : dans .cv-wrap le bouton se pose en absolu
         au coin haut droit, alors que dans .cv-opts il reste un enfant flex
         de la rangée d'actions. */
      btn.classList.toggle("ov-in-wrap", host !== opts);
    } else {
      /* Desktop : le bouton retourne dans la colonne des vues, à sa place
         d'origine (dernier de .vtabs). Le marqueur mobile doit tomber, sinon
         un simple élargissement de fenêtre le laisserait en absolu. */
      btn.classList.remove("ov-in-wrap");
      var tabs = document.querySelector(".vtabs");
      if (tabs && btn.parentNode !== tabs) tabs.appendChild(btn);
    }
  }

  /* Recale les repères de zone imprimable de la face visible.

     syncFlagSafeZones() mesure l'image affichée pour poser le cadre dessus.
     Tant qu'une face est masquée (`display:none`), ses dimensions valent 0
     et la fonction sort sans rien poser — la zone du verso restait donc
     fausse jusqu'à un resize. On la rejoue après chaque bascule.

     Le double appel différé couvre la transition CSS : la première passe
     agit dès que la face est dans le flux, la seconde une fois la mise en
     page stabilisée.

     Le REPÈRE de zone des coins est en CSS pur, donc indépendant de toute
     mesure : rien à rejouer de ce côté. Leur CADRE DE ROGNAGE, lui, se
     calcule — il est rejoué avec celui des drapeaux (voir dans `run`).     */

  function refreshFaceZones() {
    var run = function () {
      if (typeof window.syncFlagSafeZones === "function") {
        window.syncFlagSafeZones();
      }
      /* CADRE DE ROGNAGE de la face qui vient d'apparaître.

         Même cause que les zones de sécurité ci-dessus, mais ce cas n'avait
         pas été traité. syncFlagCrop et syncCoinCrop mesurent elles aussi
         l'élément (conf-flag-cover.js:75, conf-coin-cover.js:68) : sur la face
         masquée, la largeur vaut 0, elles abandonnent après 20 réessais — soit
         2 secondes — sans rien signaler.

         La face n'obtenait donc jamais son cadre : le logo restait hors de
         `.flag-crop`, sans la classe `is-cover`, et le CSS retombait sur
         `contain`. Le design était bien là, mais en petite vignette mal
         placée — ce qui se lit comme un design perdu.

         C'est ICI que la reprise doit vivre, et nulle part ailleurs : c'est le
         seul instant où la face est enfin mesurable. La rejouer depuis
         l'ouverture d'un article du panier échouerait de la même façon, le
         verso y étant encore masqué. */
      /* QUOTA RÉARMÉ AVANT DE SYNCHRONISER.

         Les reprises de syncFlagCrop / syncCoinCrop sont bornées à 20, et le
         compteur ne repart qu'après un succès. Or la face qu'on vient
         d'afficher était masquée jusqu'ici : chaque tentative sur elle a
         échoué et consommé un jeton. Le budget est donc souvent épuisé au
         moment précis où la face devient enfin mesurable — la bascule
         manuelle, seul recours du client, restait alors sans effet. */
      if (typeof window.resetFlagCropRetries === "function") window.resetFlagCropRetries();
      if (typeof window.resetCoinCropRetries === "function") window.resetCoinCropRetries();

      if (typeof window.syncFlagCrop === "function") window.syncFlagCrop();
      if (typeof window.syncCoinCrop === "function") window.syncCoinCrop();

      /* Un design déjà déposé doit rester dans les nouvelles bornes.
         APRÈS le cadre : clampFlagLogo borne le logo dans son parent, et ce
         parent n'est le bon qu'une fois `.flag-crop` posé. Appelé avant, il
         bornait une géométrie correcte dans le mauvais référentiel. */
      if (typeof window.clampFlagLogo === "function") {
        window.clampFlagLogo();
      }
    };
    requestAnimationFrame(run);
    setTimeout(run, 260);
  }

  function buildFaceSwitch() {
    if (!isMobile()) return;

    var stage = document.querySelector(".flag-stage, .coin-stage");
    var wrap = document.querySelector(".cv-wrap");
    if (!stage || !wrap) {
      // Produit textile (ou canvas pas encore construit) : pas de bascule.
      var old = document.getElementById("face-switch");
      if (old) old.remove();
      /* L'ATTRIBUT PART AVEC ELLE.

         Il était laissé sur la racine : revenir d'un coin vers un textile
         gardait `data-face-active="verso"`, et le CSS continuait d'y accrocher
         la mise en évidence d'une zone d'upload — un cadre orange sur un
         vêtement, sans rien qui l'explique.

         L'autre branche de sortie le nettoie déjà (voir plus bas) ; celle-ci
         l'avait oublié. */
      refletFaceActive(null);
      return;
    }

    /* Les faces réellement AFFICHABLES. Les patchs n'ont qu'un recto, et la
       vue « côté » des coins est masquée par conf-patches.css : on ne
       propose donc la bascule QUE s'il y a bien deux faces à départager.

       Le test porte sur la DISPONIBILITÉ, pas sur la simple présence dans
       le DOM : en « recto simple », selectCoinType() (conf-patches.js)
       laisse la vue verso en place avec `display: none`. La chercher au
       sélecteur seul la comptait comme disponible, et la bascule
       Recto/Verso restait affichée alors qu'il n'y a qu'une face à voir.

       On lit le style INLINE, et non la visibilité calculée : la bascule
       elle-même masque la face inactive en CSS (`data-face-active`), donc
       tester le rendu ferait disparaître la bascule dès le premier clic —
       la face qu'elle vient de cacher serait comptée comme absente.
       `style.display` n'est écrit que par selectCoinType(), qui exprime bien
       le choix du client. */
    function available(el) {
      return !!el && el.style.display !== "none";
    }

    /**
     * Reporte la face affichée sur la RACINE de l'application.
     *
     * Les zones d'upload vivent dans la feuille latérale, hors de la scène :
     * un sélecteur CSS ne pouvait donc pas remonter jusqu'à l'attribut de
     * celle-ci. En le reflétant sur `.conf-app-root`, ancêtre commun, le CSS
     * met en évidence la zone correspondante sans une ligne de logique
     * supplémentaire (voir conf-mobile.css, « ZONE D'UPLOAD »).
     *
     * @param {string|null} face - 'recto', 'verso', ou null pour effacer
     */
    function refletFaceActive(face) {
      var root = document.querySelector(".conf-app-root");
      if (!root) return;
      if (face) root.setAttribute("data-face-active", face);
      else root.removeAttribute("data-face-active");
    }

    var faces = [];
    if (
      available(stage.querySelector("#flag-recto")) ||
      available(stage.querySelector('.coin-view[data-view="recto"]'))
    ) {
      faces.push("recto");
    }
    if (
      available(stage.querySelector("#flag-verso")) ||
      available(stage.querySelector('.coin-view[data-view="verso"]'))
    ) {
      faces.push("verso");
    }

    var existing = document.getElementById("face-switch");
    if (faces.length < 2) {
      if (existing) existing.remove();
      stage.removeAttribute("data-face-active");
      /* Une seule face : plus rien à distinguer, la mise en évidence n'aurait
         pas de sens — et laisserait un cadre orange sans contrepartie. */
      refletFaceActive(null);
      return;
    }

    // Face courante conservée d'un rafraîchissement à l'autre.
    var current = stage.getAttribute("data-face-active");
    if (faces.indexOf(current) === -1) current = "recto";
    stage.setAttribute("data-face-active", current);
    refletFaceActive(current);

    /* Déjà en place et rattachée au bon aperçu : on n'y touche pas.
       Important — cette fonction écrit dans .canvas, que watchStage()
       observe : reconstruire à chaque appel relancerait l'observateur en
       boucle. Sortir tôt rend l'opération idempotente. */
    if (existing && existing.parentNode === wrap) {
      var btns = existing.querySelectorAll(".face-switch-btn");
      if (btns.length === faces.length) {
        /* Rien à reconstruire, mais la géométrie a pu changer (canvas
           réécrit, image rechargée) : les zones, elles, sont à recaler. */
        refreshFaceZones();
        return;
      }
    }

    var box = existing;
    if (!box || box.parentNode !== wrap) {
      if (box) box.remove();
      box = document.createElement("div");
      box.id = "face-switch";
      box.className = "face-switch";
      // Dans .cv-wrap, qui est le référent positionné de l'aperçu.
      wrap.appendChild(box);
    }

    box.innerHTML = "";
    faces.forEach(function (f) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "face-switch-btn" + (f === current ? " active" : "");
      b.textContent = f === "recto" ? "Recto" : "Verso";
      b.addEventListener("click", function () {
        // Reclic sur la face déjà affichée : rien à retourner.
        if (stage.getAttribute("data-face-active") === f) return;

        stage.setAttribute("data-face-active", f);
        refletFaceActive(f);
        box.querySelectorAll(".face-switch-btn").forEach(function (o) {
          o.classList.remove("active");
        });
        b.classList.add("active");

        /* Retournement de la pièce (voir .coin-flipping, conf-mobile.css).
           La classe est retirée à la FIN réelle de l'animation plutôt
           qu'après un délai deviné ; le repli au timer couvre le cas où
           l'événement ne vient pas (animation désactivée par
           prefers-reduced-motion, onglet en arrière-plan). */
        stage.classList.remove("coin-flipping");
        void stage.offsetWidth;           // relance l'animation
        stage.classList.add("coin-flipping");

        var done = function () {
          stage.classList.remove("coin-flipping");
          clearTimeout(timer);
        };
        var timer = setTimeout(done, 600);
        stage.addEventListener("animationend", done, { once: true });

        /* La face qu'on vient d'afficher était en `display:none` : ses
           dimensions valaient 0, donc syncFlagSafeZones() (drapeaux) et
           syncCoinSafeZones() (coins) s'étaient interrompus sans poser sa
           zone imprimable — d'où un cadre faux sur le verso.
           On les rejoue maintenant que la face a une géométrie réelle. */
        refreshFaceZones();
      });
      box.appendChild(b);
    });

    /* Première pose : le verso est masqué d'emblée, sa zone n'a donc jamais
       été calculée non plus. */
    refreshFaceZones();
  }

  /* Le canvas est reconstruit à chaque changement de produit
     (conf-dynamic-layout.js réécrit .cv-wrap) : la bascule disparaît avec
     lui. On la reconstruit dès que le conteneur change. */
  function watchStage() {
    var host = document.querySelector(".canvas");
    if (!host) return;

    var pending = false;
    var obs = new MutationObserver(function (mutations) {
      /* Les CALQUES DÉPLAÇABLES sont ignorés — même raison que dans
         watchImages() plus haut, et c'est le SECOND déclencheur du même
         défaut.

         `subtree: true` + `style` sur `.canvas` capte chaque `style.left` /
         `style.width` qu'écrit un glisser-déposer, `.canvas` étant un ancêtre
         de #logo-f, #logo-fr et #logo-b. Le rappel enchaîne alors
         syncLayerToImage → applyMobileZones → reflowLogos →
         placeLogoInZone(), qui RECALCULE la position depuis `startLeft` et
         RÉÉCRIT `style.width` depuis `startW` (conf-main-inline.js:1561-1606).

         D'où les DEUX symptômes signalés : le logo revient à sa place ET ne
         peut pas être redimensionné — un seul appel annule les deux gestes.

         Le texte y échappait : clampTextToZone() LIT la position courante et
         se contente de la borner, là où placeLogoInZone() l'ignore et la
         recalcule. reflowTexts() est idempotent, reflowLogos() est destructif
         — d'où l'illusion que le texte était déjà réglé. */
      var pertinent = mutations.some(function (m) {
        var t = m.target;
        if (!t || typeof t.closest !== 'function') return true;
        return !t.closest('.design-logo, .design-text');
      });
      if (!pertinent) return;

      // Le canvas se réécrit en plusieurs mutations : on ne rebâtit qu'une
      // fois, à la fin du lot.
      if (pending) return;
      pending = true;
      setTimeout(function () {
        pending = false;
        /* Re-test du verrou DANS le différé : `setManipulating(false)` est
           levé de façon synchrone à touchend (conf-logo-drag.js:849), donc
           bien avant ces 60 ms. Un geste enchaîné rapidement serait sinon
           écrasé par ce lot. */
        if (window.__logoManipulating) return;

        /* NE PAS SE RÉVEILLER SUR SES PROPRES ÉCRITURES.

           `fillActionBar` écrit DANS `.canvas` — le prix, le bouton flottant,
           le bouton « Taille · Qté ». Cet observateur surveille ce même
           sous-arbre et la rappelle : elle se redéclenchait donc elle-même
           toutes les 60 ms, en permanence, pendant toute la session mobile.

           Conséquence visible : le menu natif des tailles se refermait aussitôt
           ouvert, le sous-arbre étant reconstruit sous lui une quinzaine de fois
           par seconde.

           L'observateur du RÉCAP porte déjà exactement cette garde (:787), avec
           un commentaire qui chiffre le défaut qu'elle corrige — « 3004
           mutations en 3 s ». Elle manquait ici.

           250 ms : une réécriture légitime (changement de produit, de quantité)
           vient d'une action du client, jamais dans les 250 ms qui suivent notre
           propre écriture. Elle n'est donc pas masquée. */
        tagCanvasRow();
        buildFaceSwitch();
        /* conf-dynamic-layout.js réécrit .canvas en entier au changement de
           produit : le prix, le bouton flottant et « Vue d'ensemble », qui y
           sont ancrés, sont détruits avec. On les réinstalle. */
        moveOverviewBtn();

        /* ⚠️ LA GARDE NE PROTÈGE QUE `fillActionBar`, PAS TOUT LE BLOC.

           Elle était testée en tête, et emportait donc les cinq autres appels
           avec elle. Or une seule d'entre elles écrit dans `.canvas` — donc une
           seule peut se rappeler elle-même. Les autres n'ont rien à voir avec
           la boucle qu'elle ferme.

           CE QUE CETTE PORTÉE TROP LARGE COÛTAIT : la bascule Recto/Verso des
           coins ne revenait pas après un changement de produit. Le dernier
           écrivain de la séquence est `selectCoinType` (conf-patches.js), qui
           pose `display` sur la vue verso à ~300 ms — juste après qu'un lot
           précédent a rappelé `fillActionBar` et RÉ-ARMÉ la garde. Son lot
           arrivait donc dans l'ombre, était rejeté, et plus rien ne réveillait
           l'observateur : les deux faces restaient affichées côte à côte.

           Au rafraîchissement, `selectCoinType` est programmée à 600 ms
           (conf-sidebar-modern.js) au lieu de 300 : hors de la fenêtre, d'où un
           défaut qui ne se voyait qu'en navigation.

           La boucle documentée reste fermée par la même ligne qu'avant —
           seule `fillActionBar` en dépendait. */
        if (Date.now() - _fabDerniereEcriture >= 250) fillActionBar();

        syncLayerToImage();
        watchZoomEnd();   // .cv-single-view est neuf : réinstaller l'écouteur
      }, 60);
    });
    /* `attributes: style` en plus de childList : passer le coin en « recto
       simple » ne reconstruit rien — selectCoinType() se contente de poser
       `display: none` sur la vue verso. Sans cette surveillance, la bascule
       Recto/Verso restait affichée pour une face qui n'existe plus.
       Le lot de 60 ms absorbe les écritures multiples de selectCoinType. */
    obs.observe(host, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["style"],
    });
  }

  /* ── Zones (poitrine, dos) : identiques au desktop ──────────────────
     Le mobile ne redéfinit RIEN. buildZones() (conf-main-inline.js) écrit
     les zones dans window.LOGO_ZONES en % de l'image du produit, et
     syncLayerToImage() cale #logo-layer sur cette même image telle
     qu'affichée : les pourcentages du layer sont donc DÉJÀ ceux du
     desktop, sans conversion.

     Une version antérieure divisait les zones par --img-fill, en croyant
     compenser un écart de cadrage. C'était faux : --img-fill agrandit
     l'image ET le layer dans les mêmes proportions, la division rendait
     donc les zones plus petites qu'en desktop.

     Ces deux fonctions sont conservées (elles sont appelées depuis
     syncLayerToImage() et init()) mais ne font plus rien : les supprimer
     imposerait de toucher à ces appels sans bénéfice. */

  /* ── Zones MOBILE ───────────────────────────────────────────────────
     Valeurs PROPRES au mobile, en % de l'IMAGE (le layer y est calé, voir
     syncLayerToImage). Elles n'ont pas à égaler celles du desktop, qui
     s'expriment dans un autre référentiel (le conteneur) — ce qui compte
     est qu'elles délimitent la même surface sur le vêtement.

     Repère : le vêtement occupe ~68,6 % de la largeur de l'image (mesuré
     dans les PNG). Une zone de 50 % de l'image couvre donc environ 73 % du
     torse, soit d'une couture d'épaule à l'autre.

     Ces valeurs se calent visuellement, par ajustements successifs. */
  /* Hauteur portée de 9 % à 14 %.

     Le calque mobile est calé sur les pixels DESSINÉS de l'image (carrée,
     500x500 — voir syncLayerToImage), alors que le desktop l'étale sur le
     conteneur, plus large que haut. À largeur égale en %, un logo occupe
     donc une part de HAUTEUR bien plus grande en mobile : un visuel carré à
     9 % de large y fait déjà 9 % de haut, et le moindre agrandissement — ou
     tout visuel plus haut que large — dépassait les 9 % de la zone.

     La plage verticale de clampLogoToZone() devenait alors vide et le logo
     se retrouvait replaqué sur le bord haut à chaque touchmove : il ne
     suivait plus le doigt. 14 % laisse passer un logo carré agrandi comme
     un visuel portrait, sans que le bandeau morde sur les coutures.

     Le `top` est remonté de 31 % à 29 % pour que le bandeau reste centré sur
     la poitrine malgré ces 5 points de hauteur supplémentaires. */
  var CHEST_MOBILE = { top: 29, width: 38, height: 14 };
  /* Dos réduit dans les mêmes proportions que le desktop (largeur ×0,90,
     hauteur ×0,88 — DOS_W_PCT 17→15,3 et DOS_H_MAX_PCT 34,3→30,3 dans
     conf-main-inline.js), pour que la surface floquable annoncée reste la même
     sur les deux affichages.

     Les VALEURS diffèrent parce que les référentiels diffèrent — ici des % de
     l'IMAGE, là des % du CONTENEUR (voir syncLayerToImage). Seul le ratio est
     transposable, jamais le nombre lui-même.

     DEUX JEUX, comme sur desktop : le sweat porte une CAPUCHE qui occupe le
     haut du panneau dos. À 22 % la zone mordait dessus — visible à l'écran, le
     pointillé remontait sur la capuche. Elle démarre donc plus bas (27,4 %,
     soit les 4 points du desktop convertis à l'échelle mobile) et sa hauteur
     est réduite d'autant pour que le bord inférieur reste au même niveau,
     bien au-dessus de l'ourlet.

     La largeur passe à 33 % : le panneau dos d'un sweat est plus large que
     celui d'un t-shirt, la zone y restait inutilement en retrait des coutures. */
  var BACK_MOBILE = { top: 22, width: 30.6, height: 40.6 };
  var BACK_MOBILE_SWEAT = { top: 27.4, width: 33, height: 35.2 };

  /* ── MANCHES (vue de côté) ──────────────────────────────────────────
     Ces zones n'étaient PAS traitées ici : elles gardaient les valeurs du
     template, exprimées en % du CONTENEUR (référentiel desktop), alors que
     le calque mobile est calé sur l'IMAGE dessinée. Le conteneur mobile
     étant nettement plus haut que l'image carrée, l'axe vertical était
     décalé — la zone tombait à côté de la manche, hors du visuel, et
     n'apparaissait donc pas à l'écran.

     Converties dans le référentiel de l'image : un `top` de 34 % du
     conteneur équivaut à ~26 % de l'image, et une hauteur de 29 % à ~43 %.
     Comme pour la poitrine et le dos, ces valeurs se calent visuellement.

     `left` est inchangé : le conteneur et l'image ont la même largeur en
     portrait (l'image est contrainte par la largeur), donc l'axe horizontal
     ne subit aucune conversion. */
  /* Zones RÉTRÉCIES, comme sur desktop (SLEEVE, conf-main-inline.js:1382).

     Le mobile portait encore les valeurs d'avant ce correctif : 9 % de large,
     soit ~16 cm — bien trop pour un logo de manche — et jusqu'à 43 % de haut
     sur le sweat, une zone qui descendait vers le poignet. Le desktop vise
     9 cm × 8 cm, converti en 5,1 % × 10,6 % dans SON référentiel.

     On transpose par RATIO (largeur ×0,567, hauteur ×0,366), jamais par copie
     du nombre : le calque mobile est calé sur l'IMAGE, le desktop sur le
     CONTENEUR (voir syncLayerToImage).

     `left` est RECALCULÉ pour conserver le CENTRE de la zone — rétrécir sans
     y toucher l'aurait décalée vers la gauche. `top` est conservé : il place
     le haut sous la couture d'épaule, ce que le rétrécissement ne change pas. */
  /* SWEAT recalé visuellement sur le rendu mobile (relevé sur capture) :
     la zone transposée depuis le desktop restait trop étroite et trop haute —
     un ruban de 5,1 × 15,7 qui montait vers la couture d'épaule alors que le
     flocage se pose plus bas sur le bras, et plus large.

     7,5 × 10 : plus large de 2,4 points, moins haut de 5,7. Le `top` descend de
     26 à 30 pour dégager l'emmanchure. La manche DROITE suit automatiquement,
     elle est dérivée en miroir (100 - left - width).

     Ces valeurs se calent à l'œil, comme le note l'en-tête des zones mobile :
     le référentiel étant l'IMAGE et non le conteneur, aucune conversion depuis
     le desktop n'est fiable au-delà d'un ordre de grandeur. */
  var SLEEVE_MOBILE = {
    sweat:  { left: 49.5, top: 30, width: 7.5, height: 10 },
    /* T-SHIRT recalé visuellement, comme le sweat : la zone transposée depuis
       le desktop tenait dans le haut de la manche courte, très au-dessus de la
       surface réellement floquée. Le tracé relevé sur capture couvre presque
       toute la manche — 9 × 12 au lieu de 5,1 × 6,9 — et démarre plus bas
       (23 au lieu de 20), son bord haut passant au milieu de l'ancien cadre.

       COTON et POLYESTER sont DISTINCTS : leurs visuels de profil n'ont pas le
       même cadrage de manche. Les deux partageaient cette entrée, si bien qu'un
       réglage juste sur l'un tombait à côté sur l'autre — la zone était bien
       posée sur le polyester et trop à droite sur le coton. Le desktop les
       sépare déjà pour la même raison (SLEEVE, conf-main-inline.js:1394-1400).

       Le coton recule de 2,5 points.

       POLYESTER ramené de 48.5 à 45.2 — MESURÉ, comme sur le desktop. À la
       hauteur de la zone, sa silhouette est centrée à 49,7 % ; la zone l'était
       à 53,0 % (48,5 + 9/2), donc décalée de 3,3 points vers la droite, mordant
       sur le torse. left = 49,7 − 9/2 = 45,2.

       Le coton confirme la règle : centré à 50,5 %, exactement comme sa
       silhouette.

       Recalé à 46.4 après contrôle visuel : le centre géométrique (45,2)
       plaçait la zone trop à gauche. Manche RAGLAN — la surface floquée est
       décalée vers l'extérieur du bras, pas centrée sur la silhouette. Même
       correction que sur le desktop (+1,2 point). */
    tshirt: { left: 46, top: 23, width: 9, height: 12 },
    tshirt_polyester: { left: 46.4, top: 23, width: 9, height: 12 },
  };

  /* Produit courant : les silhouettes diffèrent (manche longue / courte),
     comme dans buildZones(). Même test que applyZonesForProduct()
     (conf-main-inline.js) pour que les deux ne divergent pas. Le sweat est
     le produit affiché au chargement, d'où le repli. */
  function isSweatProduct() {
    var t = window.currentProductType;
    if (t == null) return true;
    return String(t).indexOf("sweat") === 0;
  }

  /* Applique les zones mobile à window.LOGO_ZONES — la source de vérité,
     lue aussi par conf-text-zone.js et par la contrainte de déplacement.
     Écrire seulement le rectangle guide élargirait le cadre à l'écran sans
     libérer le logo, qui resterait borné aux valeurs du desktop. */
  function applyMobileZones() {
    if (!isMobile()) return;
    /* Pas de verrou `__logoManipulating` ICI : cette fonction est appelée en
       fin de syncLayerToImage(), donc à chaque changement de vue. La bloquer
       pendant un geste laissait le calque calé sur la vue précédente et les
       zones (manches notamment) ne se recalculaient plus.
       Le verrou est posé dans reflowLogos(), seul endroit qui REPLACE les
       logos et qui doive donc s'effacer devant un geste en cours. */
    var Z = window.LOGO_ZONES;
    if (!Z) return;

    /* ── POITRINE ── */
    var cw = CHEST_MOBILE.width;
    var cl = 50 - cw / 2;

    ["f", "fr"].forEach(function (k) {
      var z = Z[k];
      if (!z || z.zoneId !== "zone-chest") return;
      z.left = cl;
      z.top = CHEST_MOBILE.top;
      z.width = cw;
      z.height = CHEST_MOBILE.height;

      /* maxW borne la largeur d'un logo : il doit suivre la zone, comme le
         dos (:1445) et les manches (:1480).

         OUBLIÉ ICI : la poitrine gardait la valeur du bureau (CHEST.width = 24,
         conf-main-inline.js:1507) alors que sa zone mobile en fait 38. Un logo
         restauré plus large était donc RÉDUIT par clampLogoToZone à chaque
         passage — et, sa hauteur dépassant alors les 14 % de la zone, sa
         position verticale était plaquée en haut. C'est ce qui ramenait le
         logo au centre-haut de la poitrine après restauration.

         Posé AVANT la lecture ci-dessous, qui s'en sert pour le placement
         initial. */
      z.maxW = cw;

      /* Position de départ d'un logo fraîchement posé : « cœur » à droite
         du bandeau (le cœur du porteur), « poitrine droite » à gauche. */
      var pad = cw * 0.06;
      var lw = z.maxW || 7.5;
      z.startLeft = k === "f" ? cl + cw - lw - pad : cl + pad;
    });

    var el = document.getElementById("zone-chest");
    if (el) {
      el.style.left = cl + "%";
      el.style.top = CHEST_MOBILE.top + "%";
      el.style.width = cw + "%";
      el.style.height = CHEST_MOBILE.height + "%";
    }

    /* ── DOS ──
       Jeu propre au SWEAT : sa capuche occupe le haut du panneau, la zone doit
       démarrer plus bas (voir BACK_MOBILE_SWEAT). Même distinction que le
       desktop, qui décale déjà le sweat de 4 points (conf-main-inline.js). */
    var BK = isSweatProduct() ? BACK_MOBILE_SWEAT : BACK_MOBILE;
    var bw = BK.width;
    var bl = 50 - bw / 2;
    var zb = Z["b"];
    if (zb) {
      zb.left = bl;
      zb.top = BK.top;
      zb.width = bw;
      zb.height = BK.height;
      // maxW borne la largeur d'un logo : il doit suivre la zone.
      zb.maxW = bw;
    }

    var elb = document.getElementById("zone-b");
    if (elb) {
      elb.style.left = bl + "%";
      elb.style.top = BK.top + "%";
      elb.style.width = bw + "%";
      elb.style.height = BK.height + "%";
    }

    /* ── MANCHES ──
       La zone droite est le MIROIR de la gauche : il n'existe qu'une image
       de profil, retournée en scaleX pour le côté droit (voir
       conf-sleeve-side.js). D'où left = 100 - left - width, comme dans
       buildZones() et dans le template. */
    /* Selection PAR TYPE, comme le desktop (conf-main-inline.js:1458) :
       coton et polyester ont leur propre zone. Repli sur « tshirt » pour un
       type inconnu, plutôt que de casser le rendu. */
    var SLV = isSweatProduct() ? SLEEVE_MOBILE.sweat
      : (SLEEVE_MOBILE[window.currentProductType] || SLEEVE_MOBILE.tshirt);
    var sides = {
      sl: { zoneId: "zone-sl", left: SLV.left },
      sr: { zoneId: "zone-sr", left: 100 - SLV.left - SLV.width },
    };

    Object.keys(sides).forEach(function (k) {
      var cfg = sides[k];
      var z = Z[k];
      if (z) {
        z.left = cfg.left;
        z.top = SLV.top;
        z.width = SLV.width;
        z.height = SLV.height;
        // maxW borne la largeur d'un logo : il doit suivre la zone.
        z.maxW = SLV.width;
      }
      var els = document.getElementById(cfg.zoneId);
      if (els) {
        els.style.left = cfg.left + "%";
        els.style.top = SLV.top + "%";
        els.style.width = SLV.width + "%";
        els.style.height = SLV.height + "%";
      }
    });

    reflowLogos();
  }

  /* Replace les logos DÉJÀ posés dans les zones qu'on vient de redéfinir.

     Sans cela, un visuel uploadé garde la position calculée sur les zones
     du desktop : placeLogoInZone() a tourné AVANT applyMobileZones(), donc
     sur d'autres bornes. Le logo apparaissait hors de son cadre — surtout
     visible au dos, où l'écart de largeur est le plus grand.

     Seulement pour les zones RENSEIGNÉES : replacer un calque vide n'a pas
     de sens.

     applyMobileZones() ne tourne qu'au changement d'image (vue, produit,
     couleur) — pas pendant un glisser-déposer : une position réglée à la
     main n'est donc pas écrasée en cours de manipulation. */
  function reflowLogos() {
    if (typeof window.placeLogoInZone !== "function") return;
    /* Geste en cours : placeLogoInZone() RECENTRE le logo dans sa zone. Le
       rejouer pendant un glisser-déposer annulait le déplacement à chaque
       mouvement. Le commentaire ci-dessus supposait que cette fonction ne
       tourne jamais pendant un drag — c'est faux : ses observateurs
       réagissent aux styles qu'écrit le drag lui-même. */
    if (window.__logoManipulating) return;

    /* OUVERTURE DEPUIS LE PANIER : on ne replace rien.

       placeLogoInZone() plus bas RECALCULE position et taille depuis les
       valeurs de départ de la zone, et les PERSISTE (conf-main-inline.js:1654).
       Rejouée pendant une restauration — ce que font les observateurs mobiles
       à chaque rechargement d'image — elle écrasait la géométrie que le panier
       venait de reposer, puis l'enregistrait : la passe suivante trouvait une
       géométrie « valide » mais fausse, et le design ne revenait plus jamais.

       Même garde que saveLogosForProduct (conf-logo-store.js:34) et
       elaguerUploads (conf-main-inline.js:5944). Le drapeau couvre toute la
       durée de l'ouverture ; les restaurateurs posent eux-mêmes la géométrie
       enregistrée, il n'y a rien à recaler ici. */
    if (window.__ouvertureDepuisPanier) return;

    var Z = window.LOGO_ZONES;
    if (!Z) return;

    /* Géométrie déjà enregistrée ? On la lit UNE fois pour tout le lot : le
       magasin vit dans sessionStorage, le relire par zone coûterait cinq
       désérialisations à chaque recalage. */
    var store = (typeof window.readUploadStore === 'function')
      ? window.readUploadStore()
      : null;
    var parProduit = (store && store.byProduct &&
                      store.byProduct[window.currentProductType]) || {};

    /* REPLI SUR LA RÉSERVE MÉMOIRE quand la session est muette.

       readUploadStore ne lit QUE sessionStorage. Or son écriture échoue sur un
       design lourd (quota ~5 Mo) : `parProduit` était alors vide, aucune
       géométrie n'était trouvée, et les cinq zones partaient en replacement —
       exactement ce que la restauration venait d'éviter.

       La réserve porte le design complet d'une ligne de panier, hors session
       (conf-cart-open-design.js:239). La consulter suffit à faire reconnaître
       la géométrie et à basculer sur clampLogoToZone, qui borne sans replacer. */
    if (!Object.keys(parProduit).length) {
      var res = window.__uploadsAAppliquer;
      if (res && res.byProduct) {
        parProduit = res.byProduct[window.currentProductType] || {};
        /* Produit inconnu : une ligne de panier ne concerne qu'un seul
           produit — s'il n'y a qu'une entrée, c'est la bonne. */
        if (!Object.keys(parProduit).length) {
          var cles = Object.keys(res.byProduct);
          if (cles.length === 1) parProduit = res.byProduct[cles[0]] || {};
        }
      }
    }

    // Manches incluses : leurs zones sont désormais recalculées pour le
    // mobile (voir SLEEVE_MOBILE), un logo posé doit suivre.
    ["f", "fr", "b", "sl", "sr"].forEach(function (k) {
      var z = Z[k];
      if (!z) return;
      var logo = document.getElementById(z.logoId);
      if (!logo || logo.style.display === "none") return;
      var im = logo.querySelector("img");
      if (!im || !im.getAttribute("src")) return;

      /* CLIENT AYANT DÉJÀ RÉGLÉ CE LOGO : on BORNE, on ne replace pas.

         placeLogoInZone() ignore la position et la taille courantes et les
         recalcule depuis `startW` / `startLeft` (conf-main-inline.js:1561-1606),
         puis les persiste (:1614-1620). Rejouée après un geste — ce que font
         plusieurs observateurs mobiles — elle annulait donc le déplacement ET
         le redimensionnement, et écrasait la géométrie enregistrée.

         Le verrou `__logoManipulating` ne peut pas l'empêcher : setManipulating
         (conf-logo-drag.js:252-262) modifie une classe sur #logo-layer — le
         CONTENEUR — une ligne APRÈS avoir levé le verrou. Cette mutation
         traverse donc tous les filtres et arrive verrou déjà baissé.

         clampLogoToZone() lit la géométrie courante et se contente de la borner
         à la zone : idempotente, comme clampTextToZone pour les textes. C'est
         précisément pourquoi le texte n'a jamais eu ce défaut.

         placeLogoInZone reste le chemin du PREMIER placement, quand aucune
         géométrie n'a encore été enregistrée. */
      var dejaRegle = parProduit[k] && parProduit[k].geo;
      if (dejaRegle && typeof window.clampLogoToZone === 'function') {
        window.clampLogoToZone(k);
      } else {
        window.placeLogoInZone(k);
      }
    });

    reflowTexts();
  }

  /* Même problème pour les TEXTES : clampTextToZone() les positionne à la
     création, avec les zones alors en vigueur (celles du desktop). Nos
     valeurs mobile arrivent après — le texte restait donc calé sur les
     anciennes bornes, souvent très loin de son cadre.

     clampTextToZone() lit TEXT_ZONE_HORIZ, dérivé dynamiquement de
     LOGO_ZONES : le rejouer suffit à replacer le texte, sans dupliquer le
     moindre calcul. */
  function reflowTexts() {
    if (typeof window.clampTextToZone !== "function") return;

    ["f", "fr", "b"].forEach(function (k) {
      var el = document.getElementById("text-" + k);
      if (!el || el.style.display === "none") return;
      window.clampTextToZone(k);
    });
  }

  /* Un texte AJOUTÉ après coup n'est pas couvert par reflowTexts() : la
     dernière application de zones a eu lieu avant sa création.

     Les éléments .design-text existent dès le HTML (masqués) et passent en
     `display: block` à l'ajout : on observe donc leur style. Le clamp est
     rejoué une fois la police chargée, sans quoi la mesure porterait sur la
     police de repli. */
  /* Le zoom automatique (upload comme ajout de texte) anime `transform` sur
     .cv-single-view pendant 0,2 s. Toute mesure prise pendant ce laps —
     clampTextToZone, placeLogoInZone — porte sur une géométrie
     intermédiaire, et pose l'élément à côté de sa zone.

     On écoute donc la FIN réelle de la transition plutôt que de deviner un
     délai, et on replace tout ce qui est posé. */
  function watchZoomEnd() {
    var view = document.querySelector(".cv-single-view");
    if (!view || view.dataset.zoomWatched === "1") return;

    // Marqué : le canvas est reconstruit au changement de produit, et cette
    // fonction est rejouée — sans le drapeau, les écouteurs s'empileraient.
    view.dataset.zoomWatched = "1";
    view.addEventListener("transitionend", function (e) {
      if (e.propertyName !== "transform") return;
      if (!isMobile()) return;
      /* Recale le calque avant de replacer quoi que ce soit : la vue a pu
         changer pendant l'animation, et les zones se recalculent dans la
         foulée (applyMobileZones est appelée en fin de syncLayerToImage). */
      syncLayerToImage();
      reflowTexts();
      reflowLogos();
    });
  }

  /* Les menus « Police » / couleur sont gérés dans conf-text-toolbar.js :
     déplacés dans <body> à l'ouverture, puis positionnés sous leur bouton.
     Le rognage venait de `overflow: hidden` sur .cv-wrap, commun au desktop
     et au mobile — le corriger ici seulement laissait le desktop cassé. */

  function watchTexts() {
    ["f", "fr", "b"].forEach(function (k) {
      var el = document.getElementById("text-" + k);
      if (!el) return;

      /* clampTextToZone() écrit lui-même dans `style` : sans ce verrou,
         l'observateur se rappellerait en boucle. Le drapeau est levé le
         temps du clamp, puis retombé au tour de boucle suivant. */
      var busy = false;

      new MutationObserver(function () {
        if (busy) return;
        if (!isMobile()) return;
        // Geste en cours : le clamp différé écraserait la position réglée.
        if (window.__logoManipulating) return;
        if (el.style.display === "none") return;
        if (typeof window.clampTextToZone !== "function") return;

        busy = true;
        requestAnimationFrame(function () {
          window.clampTextToZone(k);
          setTimeout(function () { busy = false; }, 0);
        });
      }).observe(el, { attributes: true, attributeFilter: ["style"] });
    });
  }

  /* applyZonesForProduct() reconstruit LOGO_ZONES au changement de produit
     et réécrit les rectangles guides : nos valeurs seraient perdues. On les
     réapplique dès que le rectangle change.

     Le test de largeur évite la boucle : applyMobileZones() écrit elle-même
     ce style, ce que l'observateur détecterait aussitôt. */
  function watchChestZone() {
    var chest = document.getElementById("zone-chest");
    /* Les MANCHES sont surveillées aussi : applyZonesForProduct() réécrit
       leurs rectangles avec les valeurs desktop, qui ne valent pas dans le
       référentiel mobile. Sans cet observateur, elles restaient décalées
       jusqu'au prochain changement d'image. */
    var sleeve = document.getElementById("zone-sl");
    if (!chest && !sleeve) return;

    /* Le test d'écart évite la boucle : applyMobileZones() écrit elle-même
       ces styles, ce que l'observateur détecterait aussitôt. */
    function stale() {
      if (chest && parseFloat(chest.style.width) !== CHEST_MOBILE.width) return true;
      if (sleeve) {
        /* Selection PAR TYPE, comme le desktop (conf-main-inline.js:1458) :
           coton et polyester ont leur propre zone. Repli sur  pour un
           type inconnu, plutot que de casser le rendu. */
        var SLV = isSweatProduct() ? SLEEVE_MOBILE.sweat
          : (SLEEVE_MOBILE[window.currentProductType] || SLEEVE_MOBILE.tshirt);
        if (parseFloat(sleeve.style.top) !== SLV.top) return true;
        if (parseFloat(sleeve.style.height) !== SLV.height) return true;
      }
      return false;
    }

    var obs = new MutationObserver(function () {
      if (!isMobile()) return;
      if (window.__logoManipulating) return;   // geste en cours : ne pas replacer
      if (stale()) applyMobileZones();
    });
    [chest, sleeve].forEach(function (el) {
      if (el) obs.observe(el, { attributes: true, attributeFilter: ["style"] });
    });
  }

  // Conservée : appelée depuis init(). Les zones passent par applyMobileZones().
  function widenChestZone() {
    applyMobileZones();
  }

  /* ── Init ─────────────────────────────────────────────────────────── */

  /* ═══════════ GARDIEN DE GÉOMÉTRIE (ouverture depuis le panier) ═══════════

     Trois écrivains distincts replaçaient le logo après sa restauration, et
     les neutraliser un par un a échoué trois fois — le suivant reprenait.
     On surveille donc la CIBLE plutôt que les écrivains : toute divergence
     par rapport à la géométrie publiée par conf-cart-open-design.js est
     corrigée sur-le-champ, quelle qu'en soit l'origine.

     Deux d'entre eux vivent dans conf-main-inline.js (placeLogoInZone via
     restoreUploads, clampLogoToZone via applyZonesForProduct), partagé avec
     le bureau qui fonctionne : ils ne peuvent pas être modifiés.

     TROIS PROTECTIONS CONTRE L'EMBALLEMENT, cumulées :
       a) n'écrire QUE si la valeur diffère — sans quoi aucune notification ;
       b) purger les notifications que l'on vient de provoquer ;
       c) un verrou de réentrance pendant l'écriture.

     Le gardien s'efface devant le client : il se coupe au premier geste et
     s'arrête de toute façon après GARDE_MS. Mobile uniquement. */
  var GARDE_MS = 1600;   // couvre les deux passes (700 ms) + la marge du drapeau

  function installerGardienGeo() {
    var ZONES = ["f", "fr", "b", "sl", "sr"];
    var obs = null, minuteur = null, actif = false, enCours = false;

    /** Repose la géométrie publiée d'une zone. @returns {boolean} corrigée ? */
    function reposer(zone) {
      var reg = window.__geoOuverture;
      var g = reg && reg[zone];
      if (!g) return false;
      var el = document.getElementById(g.id);
      if (!el) return false;

      var change = false;
      if (g.left != null && el.style.left !== g.left) { el.style.left = g.left; change = true; }
      if (g.top != null && el.style.top !== g.top) { el.style.top = g.top; change = true; }
      if (g.width != null && el.style.width !== g.width) { el.style.width = g.width; change = true; }
      return change;
    }

    function reposerTout() {
      if (enCours || window.__logoManipulating) return;   // le client a la main
      enCours = true;
      try {
        var change = false;
        ZONES.forEach(function (z) { if (reposer(z)) change = true; });
        // File purgée : nos propres écritures ne doivent pas nous rappeler.
        if (change && obs) obs.takeRecords();
      } finally { enCours = false; }
    }

    function arreter() {
      if (!actif) return;
      actif = false;
      if (obs) { obs.disconnect(); obs = null; }
      if (minuteur) { clearTimeout(minuteur); minuteur = null; }
      document.removeEventListener("pointerdown", surGeste, true);
    }

    /* Le client touche un calque : sa main prime, le gardien se retire. */
    function surGeste(e) {
      var t = e.target;
      if (t && typeof t.closest === "function" &&
          t.closest(".design-logo, .design-text")) arreter();
    }

    function demarrer() {
      if (actif || !isMobile() || !window.__geoOuverture) return;
      actif = true;

      obs = new MutationObserver(function () {
        if (actif && !enCours) reposerTout();
      });

      /* Observation CIBLÉE sur les calques : seul leur attribut `style`
         compte, inutile de surveiller un ancêtre. */
      ZONES.forEach(function (z) {
        var g = window.__geoOuverture && window.__geoOuverture[z];
        var el = g && document.getElementById(g.id);
        if (el) obs.observe(el, { attributes: true, attributeFilter: ["style"] });
      });

      document.addEventListener("pointerdown", surGeste, true);
      reposerTout();                       // remise en place immédiate
      minuteur = setTimeout(arreter, GARDE_MS);
    }

    /* Le registre paraît à la première passe (+260 ms), bien après init().
       On guette donc son apparition — l'objet n'étant pas dans le DOM, un
       observateur ne conviendrait pas. Sonde légère et bornée. */
    var sonde = setInterval(function () {
      if (!window.__geoOuverture || !isMobile()) return;
      if (!actif) demarrer();
    }, 200);

    /* Une nouvelle ouverture réarme le gardien : le registre est purgé puis
       republié par conf-cart-open-design.js. */
    document.addEventListener("click", function (e) {
      var t = e.target;
      if (t && typeof t.closest === "function" && t.closest(".cd-thumb")) arreter();
    }, true);

    // La sonde ne s'arrête jamais : chaque ouverture doit pouvoir l'armer.
    void sonde;
  }

  function init() {
    var panels = document.querySelectorAll(".side-panel");
    if (!panels.length) return;

    panels.forEach(addHandle);
    observePanels();
    watchUploads();
    watchFlagFr();
    watchTexts();
    watchZoomEnd();



    /* Premier clic sur le rail = ouverture volontaire. En capture, donc
       avant le handler de conf-sidebar-modern.js qui ouvre le panneau. */
    document.querySelectorAll(".icon-nav-item[data-panel]").forEach(function (item) {
      item.addEventListener(
        "click",
        function () {
          userOpened = true;
        },
        true,
      );
    });

    syncScrim();
    fillActionBar();
    observeRecap();
    observeEtapeMode();
    watchImages();
    watchNav();
    measureNav();
    syncLayerToImage();

    /* Zone poitrine : window.LOGO_ZONES est publié par conf-main-inline.js,
       lui aussi en `defer`. Il est donc prêt ici — mais applyZonesForProduct()
       peut encore le reconstruire juste après (restauration de session), d'où
       le second passage différé en plus de l'observateur. */
    widenChestZone();
    watchChestZone();
    setTimeout(widenChestZone, 800);

    /* Bascule recto/verso : le canvas des drapeaux/coins est construit
       après coup par conf-dynamic-layout.js, d'où l'observateur. */
    tagCanvasRow();
    buildFaceSwitch();
    moveOverviewBtn();
    watchStage();

    /* SIGNAL DE FIN DE RECONSTRUCTION — un ancrage qui ne dépend d'aucun délai.

       `switchLayout` (conf-dynamic-layout.js) émet `conf:layout-restored` quand
       le canvas d'un coin, d'un drapeau ou d'un patch est reconstruit ET ses
       designs restaurés. Son commentaire le dit : « un événement dit ce qu'un
       délai ne peut que supposer ». La réouverture depuis le panier s'en sert
       déjà.

       L'observateur du canvas reste le chemin principal ; celui-ci le double,
       au cas où un lot tomberait dans l'ombre d'une garde.

       `fillActionBar` est VOLONTAIREMENT ABSENTE de cette liste : elle écrit
       dans le canvas et ré-arme la garde. L'appeler ici aveuglerait
       l'observateur à l'instant précis où le dernier écrivain de la séquence
       s'apprête à agir. Le récapitulatif, lui, a son propre observateur. */
    document.addEventListener("conf:layout-restored", function () {
      if (!isMobile()) return;
      tagCanvasRow();
      buildFaceSwitch();
      moveOverviewBtn();
      syncLayerToImage();
      watchZoomEnd();
    });

    /* Protège la géométrie restaurée à l'ouverture d'un article du panier.
       N'entre en action que lorsque conf-cart-open-design.js publie sa
       géométrie cible — inerte le reste du temps. */
    installerGardienGeo();

    /* Rotation / redimensionnement : en repassant en desktop le voile doit
       disparaître, et les panneaux retrouver le comportement permanent. */
    var mq = window.matchMedia(MQ);
    var onChange = function () {
      if (!isMobile()) {
        /* ZONES DU BUREAU RÉTABLIES.

           applyMobileZones (:1416) n'a pas ses propres zones : elle ÉCRASE les
           propriétés de window.LOGO_ZONES, l'objet que le bureau partage. Les
           valeurs d'origine sont donc perdues, pas mises de côté.

           Or applyZonesForProduct — la seule fonction qui les reconstruise —
           n'est appelée qu'au CHANGEMENT DE PRODUIT
           (conf-main-inline.js:2210, :2292) et au chargement (:923). Rien ne
           réagissait au redimensionnement : en revenant d'une largeur mobile,
           les zones gardaient leurs dimensions mobiles, plus larges et plus
           hautes, jusqu'au prochain changement de produit.

           On rappelle donc cette fonction : elle repart des constantes en
           centimètres (buildZones), reporte les bornes sur les rectangles
           pointillés, et recontraint les logos et textes déjà posés
           (:1617-1620). Rien à recopier ici — une sauvegarde des valeurs du
           bureau serait une seconde source de vérité, vouée à diverger.

           DIFFÉRÉ : la mise en page doit d'abord reprendre ses dimensions de
           bureau. Mesurée trop tôt, elle le serait sur un canvas encore
           étroit. */
        setTimeout(function () {
          if (isMobile()) return;   // bascule à nouveau entre-temps
          if (typeof window.applyZonesForProduct === 'function' &&
              typeof window.currentProductType === 'string') {
            window.applyZonesForProduct(window.currentProductType);
          }
        }, 120);

        removeActionBar();
        showScrim(false);
        document.querySelectorAll(".side-panel").forEach(function (p) {
          p.style.transform = "";
          p.style.transition = "";
        });
        // Desktop : la sidebar ne reste jamais vide.
        if (!document.querySelector(".side-panel.open")) {
          var el = document.getElementById("panel-product");
          var nav = document.querySelector('[data-panel="panel-product"]');
          if (el) el.classList.add("open");
          if (nav) nav.classList.add("active");
        }
        /* Desktop : la bascule n'a plus lieu d'être, et l'attribut doit
           partir avec elle — sinon une des deux faces resterait masquée
           alors que l'écran a la place de montrer les deux. */
        var fs = document.getElementById("face-switch");
        if (fs) fs.remove();
        document
          .querySelectorAll(".flag-stage, .coin-stage")
          .forEach(function (s) {
            s.removeAttribute("data-face-active");
          });
      } else {
        syncScrim();
        fillActionBar();
        buildFaceSwitch();
      }
      moveOverviewBtn();    // remet le bouton dans le bon conteneur
      measureNav();         // desktop : retire --nav-h ; mobile : (re)mesure
      syncLayerToImage();   // dans les deux sens : pose ou retire le calage
    };
    if (mq.addEventListener) mq.addEventListener("change", onChange);
    else if (mq.addListener) mq.addListener(onChange);

    /* Clic / tap à l'extérieur : ferme la feuille. En capture (voir
       onDocPointerDown). pointerdown couvre souris et tactile. */
    document.addEventListener("pointerdown", onDocPointerDown, true);

    /* Choix d'un produit dans la feuille : elle se referme (en bulle, donc
       après le handler d'origine). */
    document.addEventListener("click", onPanelSelect, false);

    /* Échap ferme la feuille (clavier physique / tablette). */
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && isMobile()) closeSheet();
    });
  }

  /* Les panneaux existent dès le HTML, mais conf-sidebar-modern.js pose
     .open au boot : on s'initialise après lui pour observer dès le départ. */
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      setTimeout(init, 0);
    });
  } else {
    setTimeout(init, 0);
  }

  /* ══════════════════════════════════════════════════════════════════════
     COMMANDE DE GROUPE — lignes repliables, numérotées, résumées

     Le CSS transforme le tableau en liste (conf-mobile.css). Il manque le
     comportement : numéroter, résumer une ligne repliée, et la déplier au
     toucher.

     TOUT EST ICI, dans le fichier mobile : le tableau du bureau ne doit pas
     changer. Aucune modification de conf-main-inline.js n'est nécessaire —
     on lit le DOM qu'il produit, sans y toucher.
     ══════════════════════════════════════════════════════════════════════ */

  /** Résumé d'une ligne repliée : « M · Black · ×2 ». */
  function grpMajResume(tr) {
    if (!tr) return;
    var td = tr.querySelector('td:nth-child(1)');
    if (!td) return;

    var taille = (tr.querySelector('.grp-f-size') || {}).value || '';
    var couleur = (tr.querySelector('.grp-f-color') || {}).value || '';
    var qte = (tr.querySelector('.grp-f-qty') || {}).value || '1';

    var box = td.querySelector('.grp-resume');
    if (!box) {
      box = document.createElement('div');
      box.className = 'grp-resume';
      td.appendChild(box);
    }

    /* La pastille reprend la couleur RÉELLE : `.grp-color-dot` est déjà
       peinte par grpSyncDot (conf-main-inline.js), on relit son fond plutôt
       que de refaire la correspondance nom → teinte. */
    var source = tr.querySelector('.grp-color-dot');
    var fond = source ? source.style.background : '';

    box.innerHTML = '';

    /* DEUX GROUPES AUX EXTRÉMITÉS, CHACUN ÉTIQUETÉ.

       Les trois valeurs étaient enfilées en une phrase — « M · Noir · ×1 » —
       centrée sous le nom. Rien ne disait ce qu'elles désignaient : « M » se
       devine, mais « ×1 » se lit aussi bien comme une quantité que comme une
       référence, et la carte laissait deux grands vides sur ses côtés.

       Séparés, ils occupent la carte et se nomment. Le surnom garde le centre :
       c'est le titre de la vignette, il ne doit pas se disputer la place avec
       ses attributs.

       On construit chaque valeur par `textContent` : elles viennent de champs
       saisis ou importés d'un fichier. */
    var groupe = function (classe, libelle) {
      var g = document.createElement('span');
      g.className = 'grp-res-grp ' + classe;
      var l = document.createElement('span');
      l.className = 'grp-res-lbl';
      l.textContent = libelle;
      g.appendChild(l);
      return g;
    };

    // ── Gauche : la couleur, pastille comprise.
    var gauche = groupe('grp-res-gauche', 'Couleur');
    var valG = document.createElement('span');
    valG.className = 'grp-res-val';
    if (fond) {
      var dot = document.createElement('span');
      dot.className = 'grp-resume-dot';
      dot.style.background = fond;
      valG.appendChild(dot);
    }
    var nomCoul = document.createElement('span');
    nomCoul.textContent = couleur || '—';
    valG.appendChild(nomCoul);
    gauche.appendChild(valG);
    box.appendChild(gauche);

    // ── Droite : taille et quantité, les deux réglages chiffrés.
    var droite = groupe('grp-res-droite', 'Taille · Qté');
    var valD = document.createElement('span');
    valD.className = 'grp-res-val';
    valD.textContent = (taille || '—') + ' · ×' + qte;
    droite.appendChild(valD);
    box.appendChild(droite);
  }

  /** Renumérote et rafraîchit tous les résumés. */
  function grpMajLignes() {
    var lignes = document.querySelectorAll('#grp-rows tr');
    for (var i = 0; i < lignes.length; i++) {
      lignes[i].setAttribute('data-num', i + 1);
      grpMajResume(lignes[i]);
    }

    /* PREMIÈRE LIGNE DÉPLIÉE — le mode d'emploi le plus court qui soit.

       Montrer une ligne ouverte vaut mieux que l'expliquer : le client voit
       immédiatement ce que contient une ligne et comment la remplir. Les
       suivantes restent repliées, la liste garde sa compacité.

       Seulement si AUCUNE n'est déjà ouverte : rouvrir la modale ne doit pas
       refermer la ligne sur laquelle le client travaillait. */
    if (lignes.length && !document.querySelector('#grp-rows tr.is-open')) {
      lignes[0].classList.add('is-open');
    }
  }

  function initGroupeMobile() {
    var tbody = document.getElementById('grp-rows');
    if (!tbody || tbody.dataset.mobInit === '1') return;
    tbody.dataset.mobInit = '1';

    /* DÉPLIAGE AU TOUCHER, une ligne à la fois.

       Délégation sur le conteneur : les lignes sont créées dynamiquement — à
       l'ouverture, à l'ajout, à l'import — et s'y abonner une à une les
       manquerait.

       On ignore les clics sur un CHAMP ou un BOUTON : toucher le nom pour le
       saisir ne doit pas replier la ligne sous le doigt. */
    tbody.addEventListener('click', function (e) {
      if (!isMobile()) return;
      var tr = e.target.closest && e.target.closest('tr');
      if (!tr) return;
      if (e.target.closest('input, select, button, .grp-cpick-menu')) return;

      var ouvert = tr.classList.contains('is-open');
      tbody.querySelectorAll('tr.is-open').forEach(function (o) {
        o.classList.remove('is-open');
        grpMajResume(o);
      });
      if (!ouvert) tr.classList.add('is-open');
    });

    /* Le résumé suit les modifications : `change` couvre les listes et la
       quantité, `input` la frappe dans le nom. */
    tbody.addEventListener('change', function () { grpMajLignes(); });

    /* Lignes ajoutées ou retirées : renuméroter. Un observateur plutôt que
       des appels dans conf-main-inline.js — le bureau reste intact. */
    new MutationObserver(function () {
      if (isMobile()) grpMajLignes();
    }).observe(tbody, { childList: true });

    /* OUVERTURE DE LA MODALE : rafraîchir les lignes DÉJÀ présentes.

       L'observateur ci-dessus ne voit que les ajouts. Rouvrir une liste
       validée réutilise les lignes en place (conf-main-inline.js:93-98) sans
       en créer : sans ce rappel, elles seraient dépourvues de numéro et de
       résumé. On observe la classe `open` de l'overlay. */
    var ov = document.getElementById('grp-overlay');
    if (ov) {
      new MutationObserver(function () {
        if (isMobile() && ov.classList.contains('open')) {
          /* Différé : openGroupOrder peuple les lignes APRÈS avoir ouvert. */
          setTimeout(grpMajLignes, 0);
        }
      }).observe(ov, { attributes: true, attributeFilter: ['class'] });
    }

    grpMajLignes();
  }

  /* Exposée : l'étape « Configurer » du parcours groupe l'appelle à son
     entrée (conf-main-inline.js). L'observateur ci-dessus ne voit que les
     lignes AJOUTÉES — quand elles existent déjà, rien ne les numérotait ni
     n'en dépliait une, et le client arrivait sur des cartes toutes fermées. */
  window.grpMajLignes = function () {
    if (isMobile()) grpMajLignes();
  };

  /* La modale existe dès le rendu de la section, mais son contenu est peuplé
     à l'ouverture : on s'accroche au conteneur, pas aux lignes. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(initGroupeMobile, 0);
    });
  } else {
    setTimeout(initGroupeMobile, 0);
  }
})();
